import * as Bn from "vue";
import { ref as J, defineComponent as ft, watch as bt, openBlock as H, createElementBlock as Y, createElementVNode as w, Fragment as Ce, renderList as Ke, withDirectives as qe, vModelText as pt, vModelSelect as xs, toDisplayString as X, reactive as Cs, normalizeClass as Pe, createCommentVNode as $e, onMounted as Nn, createVNode as Tt, unref as ie, Transition as io, withCtx as lo, getCurrentScope as Qr, onScopeDispose as ea, inject as ta, computed as Oe, onUnmounted as na, shallowRef as oa, h as hn, Text as sa, createTextVNode as Lt, vModelDynamic as ra } from "vue";
import { logger as Kn } from "@myorg/type-lib";
function aa(e) {
  const t = J([]), n = J(!1), o = J(null), s = async () => {
    n.value = !0;
    try {
      t.value = await e.getConfigs();
    } catch (a) {
      o.value = a.message || "獲取配置失敗";
    } finally {
      n.value = !1;
    }
  };
  return { configs: t, isLoading: n, error: o, fetchConfigs: s, saveConfig: async (a) => {
    n.value = !0;
    try {
      await e.upsertConfig(a), await s();
    } catch (i) {
      throw o.value = i.message || "儲存配置失敗", i;
    } finally {
      n.value = !1;
    }
  } };
}
function ia(e) {
  const t = J([]), n = J(!1), o = J(!1), s = J(null);
  return {
    configs: t,
    loading: n,
    isSaving: o,
    error: s,
    loadConfigs: async () => {
      n.value = !0, s.value = null;
      try {
        const i = await e.fetchConfigs();
        t.value = i || [];
      } catch (i) {
        s.value = "無法載入時段配置", console.error("[TimeConfig] Load Failed:", i);
      } finally {
        n.value = !1;
      }
    },
    updateConfigs: async (i) => {
      o.value = !0, s.value = null;
      try {
        return await e.saveConfigs(i), t.value = [...i], !0;
      } catch (l) {
        return s.value = "儲存時段配置失敗", console.error("[TimeConfig] Save Failed:", l), !1;
      } finally {
        o.value = !1;
      }
    }
  };
}
function la(e) {
  const t = J({ 0: [], 1: [], 2: [] }), n = J(!1), o = J(!1);
  return { holidayData: t, loading: n, isSaving: o, loadHolidays: async () => {
    n.value = !0;
    try {
      t.value = await e.getHolidays();
    } catch (a) {
      console.error("Fetch failed", a);
    } finally {
      n.value = !1;
    }
  }, submitHolidays: async (a) => {
    o.value = !0;
    try {
      await e.saveHolidays(a), t.value = a;
    } finally {
      o.value = !1;
    }
  } };
}
const ca = { class: "space-y-4 p-6 bg-white rounded-2xl border border-slate-100 shadow-sm" }, ua = {
  key: 0,
  class: "py-10 text-center text-slate-700"
}, da = {
  key: 1,
  class: "space-y-3"
}, fa = ["onUpdate:modelValue"], ma = ["onUpdate:modelValue"], pa = { class: "flex items-end gap-2" }, ha = { class: "flex-1" }, wa = ["onUpdate:modelValue"], ga = ["onClick"], ba = { class: "pt-4 border-t border-slate-100 flex justify-end" }, va = ["disabled"], _a = /* @__PURE__ */ ft({
  __name: "TimeConfigManager",
  props: {
    configs: {},
    loading: { type: Boolean },
    isSaving: { type: Boolean }
  },
  emits: ["save"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = J([]);
    bt(() => n.configs, (l) => {
      s.value = JSON.parse(JSON.stringify(l));
    }, { immediate: !0 });
    const r = () => {
      s.value.push({ Start: "09:00", End: "12:00", Interval: 30 });
    }, a = (l) => {
      s.value.splice(l, 1);
    }, i = () => {
      o("save", s.value);
    };
    return (l, f) => (H(), Y("div", ca, [
      w("div", { class: "flex items-center justify-between" }, [
        f[0] || (f[0] = w("h3", { class: "text-lg font-bold text-slate-700" }, "營業時段配置", -1)),
        w("button", {
          onClick: r,
          class: "px-4 py-2 bg-indigo-100 text-indigo-700 rounded-xl text-sm font-bold hover:bg-indigo-100 transition-colors"
        }, " + 新增時段區間 ")
      ]),
      e.loading ? (H(), Y("div", ua, "讀取中...")) : (H(), Y("div", da, [
        (H(!0), Y(Ce, null, Ke(s.value, (h, b) => (H(), Y("div", {
          key: b,
          class: "group relative grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-slate-100 rounded-xl border border-transparent hover:border-indigo-100 transition-all"
        }, [
          w("div", null, [
            f[1] || (f[1] = w("label", { class: "block text-xs font-semibold text-slate-700 mb-1" }, "開始時間", -1)),
            qe(w("input", {
              type: "time",
              "onUpdate:modelValue": (m) => h.Start = m,
              class: "w-full rounded-lg border-slate-100 focus:ring-indigo-700"
            }, null, 8, fa), [
              [pt, h.Start]
            ])
          ]),
          w("div", null, [
            f[2] || (f[2] = w("label", { class: "block text-xs font-semibold text-slate-700 mb-1" }, "結束時間", -1)),
            qe(w("input", {
              type: "time",
              "onUpdate:modelValue": (m) => h.End = m,
              class: "w-full rounded-lg border-slate-100 focus:ring-indigo-700"
            }, null, 8, ma), [
              [pt, h.End]
            ])
          ]),
          w("div", pa, [
            w("div", ha, [
              f[4] || (f[4] = w("label", { class: "block text-xs font-semibold text-slate-700 mb-1" }, "間隔 (分鐘)", -1)),
              qe(w("select", {
                "onUpdate:modelValue": (m) => h.Interval = m,
                class: "w-full rounded-lg border-slate-100"
              }, [...f[3] || (f[3] = [
                w("option", { value: 15 }, "15 分鐘", -1),
                w("option", { value: 30 }, "30 分鐘", -1),
                w("option", { value: 60 }, "60 分鐘", -1)
              ])], 8, wa), [
                [
                  xs,
                  h.Interval,
                  void 0,
                  { number: !0 }
                ]
              ])
            ]),
            w("button", {
              onClick: (m) => a(b),
              class: "p-2 text-red-700 hover:text-red-700 transition-colors"
            }, [...f[5] || (f[5] = [
              w("svg", {
                class: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                w("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                })
              ], -1)
            ])], 8, ga)
          ])
        ]))), 128)),
        w("div", ba, [
          w("button", {
            onClick: i,
            disabled: e.isSaving,
            class: "px-8 py-2.5 bg-indigo-700 text-white rounded-xl font-bold hover:bg-indigo-700 disabled:opacity-100 shadow-lg shadow-indigo-100"
          }, X(e.isSaving ? "儲存中..." : "確認儲存"), 9, va)
        ])
      ]))
    ]));
  }
}), ya = { class: "space-y-4 p-6 bg-white rounded-2xl border border-slate-100 shadow-sm" }, Ea = { class: "flex justify-between items-center mb-8" }, ka = { class: "flex gap-3" }, xa = ["disabled"], Ca = {
  key: 0,
  class: "py-20 text-center bg-slate-100 rounded-3xl border-2 border-dashed border-slate-200"
}, Ta = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
}, La = ["onClick"], Na = { class: "flex items-center gap-4" }, Aa = { class: "w-12 h-12 bg-slate-100 text-slate-700 rounded-xl flex items-center justify-center text-lg font-black group-hover:bg-blue-700 group-hover:text-white transition-colors" }, Oa = { class: "font-bold text-slate-700" }, Ia = { class: "text-xs text-slate-700 font-bold" }, Sa = {
  key: 2,
  class: "fixed inset-0 bg-slate-700 backdrop-blur-sm flex items-center justify-center p-4 z-100"
}, Da = { class: "bg-white rounded-[2rem] p-8 max-w-md w-full shadow-2xl" }, Pa = { class: "text-2xl font-black text-slate-700 mb-6" }, $a = { class: "space-y-4" }, Ma = { class: "grid grid-cols-2 gap-4" }, Ra = { class: "bg-blue-100 p-5 rounded-2xl space-y-3" }, Fa = { class: "grid grid-cols-2 gap-3" }, Ua = { class: "flex gap-4 mt-8" }, Ba = /* @__PURE__ */ ft({
  __name: "TableLayoutManager",
  props: {
    configs: {},
    loading: { type: Boolean }
  },
  emits: ["save", "refresh"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = J(!1), r = Cs({}), a = (l) => {
      l ? Object.assign(r, JSON.parse(JSON.stringify(l))) : Object.assign(r, {
        id: void 0,
        table_number: n.configs.length > 0 ? Math.max(...n.configs.map((f) => f.table_number)) + 1 : 1,
        zone_id: 1,
        min_people: 2,
        max_people: 4
      }), s.value = !0;
    }, i = () => {
      o("save", { ...r }), s.value = !1;
    };
    return (l, f) => (H(), Y("div", ya, [
      w("header", Ea, [
        f[7] || (f[7] = w("div", null, [
          w("h2", { class: "text-2xl font-black text-slate-700" }, "桌位佈局管理"),
          w("p", { class: "text-sm text-slate-700" }, "管理區域、桌號與人數上限")
        ], -1)),
        w("div", ka, [
          w("button", {
            onClick: f[0] || (f[0] = (h) => l.$emit("refresh")),
            disabled: e.loading,
            class: "p-2 text-slate-700 hover:text-blue-700 transition-colors"
          }, [
            w("span", {
              class: Pe({ "animate-spin inline-block": e.loading })
            }, "🔄", 2)
          ], 8, xa),
          w("button", {
            onClick: f[1] || (f[1] = (h) => a()),
            class: "bg-blue-700 text-white px-6 py-2 rounded-xl font-bold shadow-lg hover:bg-blue-700 transition"
          }, " + 新增桌位 ")
        ])
      ]),
      e.loading && e.configs.length === 0 ? (H(), Y("div", Ca, [...f[8] || (f[8] = [
        w("p", { class: "text-slate-700 font-bold" }, "讀取配置中...", -1)
      ])])) : (H(), Y("div", Ta, [
        (H(!0), Y(Ce, null, Ke(e.configs, (h) => (H(), Y("div", {
          key: h.id,
          onClick: (b) => a(h),
          class: "bg-white p-5 rounded-2xl border border-slate-100 shadow-sm hover:border-blue-200 hover:shadow-md transition cursor-pointer flex justify-between items-center group"
        }, [
          w("div", Na, [
            w("div", Aa, X(h.table_number), 1),
            w("div", null, [
              w("div", Oa, "桌號 #" + X(h.table_number), 1),
              w("div", Ia, "區域 " + X(h.zone_id) + " • " + X(h.min_people) + "-" + X(h.max_people) + " 人", 1)
            ])
          ]),
          f[9] || (f[9] = w("span", { class: "text-blue-700 opacity-0 group-hover:opacity-100 transition-opacity text-sm font-bold" }, "編輯", -1))
        ], 8, La))), 128))
      ])),
      s.value ? (H(), Y("div", Sa, [
        w("div", Da, [
          w("h2", Pa, X(r.id ? "編輯桌位" : "新增桌位"), 1),
          w("div", $a, [
            w("div", Ma, [
              w("div", null, [
                f[10] || (f[10] = w("label", { class: "text-xs font-black text-slate-700 uppercase mb-1 block" }, "桌號", -1)),
                qe(w("input", {
                  "onUpdate:modelValue": f[2] || (f[2] = (h) => r.table_number = h),
                  type: "number",
                  class: "w-full bg-slate-100 border-none rounded-xl p-3 focus:ring-2 ring-blue-700 outline-none font-bold"
                }, null, 512), [
                  [
                    pt,
                    r.table_number,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ]),
              w("div", null, [
                f[11] || (f[11] = w("label", { class: "text-xs font-black text-slate-700 uppercase mb-1 block" }, "區域", -1)),
                qe(w("input", {
                  "onUpdate:modelValue": f[3] || (f[3] = (h) => r.zone_id = h),
                  type: "number",
                  class: "w-full bg-slate-100 border-none rounded-xl p-3 focus:ring-2 ring-blue-700 outline-none font-bold"
                }, null, 512), [
                  [
                    pt,
                    r.zone_id,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ])
            ]),
            w("div", Ra, [
              f[12] || (f[12] = w("p", { class: "text-xs font-black text-blue-700 uppercase" }, "人數設定", -1)),
              w("div", Fa, [
                qe(w("input", {
                  "onUpdate:modelValue": f[4] || (f[4] = (h) => r.min_people = h),
                  type: "number",
                  placeholder: "最小",
                  class: "w-full border-none rounded-xl p-3 shadow-inner font-bold"
                }, null, 512), [
                  [
                    pt,
                    r.min_people,
                    void 0,
                    { number: !0 }
                  ]
                ]),
                qe(w("input", {
                  "onUpdate:modelValue": f[5] || (f[5] = (h) => r.max_people = h),
                  type: "number",
                  placeholder: "最大",
                  class: "w-full border-none rounded-xl p-3 shadow-inner font-bold"
                }, null, 512), [
                  [
                    pt,
                    r.max_people,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ])
            ])
          ]),
          w("div", Ua, [
            w("button", {
              onClick: f[6] || (f[6] = (h) => s.value = !1),
              class: "flex-1 py-4 text-slate-700 font-bold"
            }, "取消"),
            w("button", {
              onClick: i,
              class: "flex-[2] py-4 bg-blue-700 text-white rounded-2xl font-black text-lg shadow-lg"
            }, "確認儲存")
          ])
        ])
      ])) : $e("", !0)
    ]));
  }
}), Va = { class: "space-y-10" }, Ha = { class: "flex items-center justify-between border-b-2 border-slate-700 pb-4" }, Ya = ["disabled"], ja = {
  key: 0,
  class: "py-10 text-center font-black text-slate-700"
}, Wa = {
  key: 1,
  class: "space-y-12"
}, Ga = { class: "grid grid-cols-7 gap-1" }, Ka = ["onClick"], qa = /* @__PURE__ */ ft({
  __name: "HolidayAdminPage",
  props: {
    holidayData: {},
    loading: { type: Boolean },
    isSaving: { type: Boolean }
  },
  emits: ["save"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = J({ 0: [], 1: [], 2: [] }), r = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"], a = J(""), i = J("");
    bt(() => n.holidayData, (b) => {
      s.value = JSON.parse(JSON.stringify(b)), a.value = s.value[2].join(", "), i.value = s.value[1].map((m) => m.toString().padStart(4, "0")).join(", ");
    }, { immediate: !0, deep: !0 });
    const l = (b) => {
      const m = s.value[0].indexOf(b);
      m > -1 ? s.value[0].splice(m, 1) : s.value[0].push(b);
    }, f = () => {
      const b = a.value.split(",").map((N) => Number.parseInt(N.trim())).filter((N) => !Number.isNaN(N) && N >= 1 && N <= 31), m = i.value.split(",").map((N) => Number.parseInt(N.trim())).filter((N) => !Number.isNaN(N) && N >= 101 && N <= 1231), x = {
        0: s.value[0],
        1: Array.from(new Set(m)).sort((N, p) => N - p),
        2: Array.from(new Set(b)).sort((N, p) => N - p)
      };
      o("save", x);
    }, h = () => {
      const b = localStorage.getItem("merchantId");
      if (b) {
        const m = `/booking/${b}`;
        window.open(m, "_blank");
      } else
        alert("找不到商家資訊，無法前往預約頁面。");
    };
    return (b, m) => (H(), Y("div", Va, [
      w("div", { class: "flex items-center gap-2 mb-4" }, [
        w("button", {
          onClick: h,
          class: "bg-blue-700 text-white px-6 py-3 font-black text-sm hover:bg-sky-700 active:scale-95 transition-all shadow-lg hover:shadow-xl"
        }, " 線上預約頁面 ")
      ]),
      w("div", Ha, [
        m[2] || (m[2] = w("h3", { class: "text-xl font-black text-slate-700 uppercase tracking-tight" }, "Holiday Configuration", -1)),
        w("button", {
          onClick: f,
          disabled: e.isSaving || e.loading,
          class: "bg-slate-700 text-white px-6 py-2 font-black text-sm hover:bg-slate-700 active:scale-95 transition-all disabled:bg-slate-100"
        }, X(e.isSaving ? "SAVING..." : "CONFIRM SAVE"), 9, Ya)
      ]),
      e.loading ? (H(), Y("div", ja, "LOADING...")) : (H(), Y("div", Wa, [
        w("section", null, [
          m[3] || (m[3] = w("div", { class: "flex items-center gap-2 mb-4" }, [
            w("span", { class: "bg-slate-700 text-white text-[10px] px-2 py-0.5 font-black" }, "TYPE 0"),
            w("h4", { class: "text-xs font-black text-slate-700 uppercase tracking-widest" }, "Weekly Recurring")
          ], -1)),
          w("div", Ga, [
            (H(), Y(Ce, null, Ke(r, (x, N) => w("button", {
              key: N,
              onClick: (p) => l(N),
              class: Pe([s.value[0].includes(N) ? "bg-slate-700 text-white" : "bg-slate-100 text-slate-700", "py-4 font-black text-xs transition-all border border-transparent hover:border-slate-700"])
            }, X(x), 11, Ka)), 64))
          ])
        ]),
        w("section", null, [
          m[4] || (m[4] = w("div", { class: "flex items-center gap-2 mb-4" }, [
            w("span", { class: "bg-slate-700 text-white text-[10px] px-2 py-0.5 font-black" }, "TYPE 2"),
            w("h4", { class: "text-xs font-black text-slate-700 uppercase tracking-widest" }, "Monthly Recurring (Days)")
          ], -1)),
          qe(w("input", {
            "onUpdate:modelValue": m[0] || (m[0] = (x) => a.value = x),
            placeholder: "Ex: 1, 15, 31",
            class: "w-full bg-slate-100 border-l-4 border-slate-700 p-4 font-black text-slate-700 outline-none focus:bg-white transition-colors"
          }, null, 512), [
            [pt, a.value]
          ]),
          m[5] || (m[5] = w("p", { class: "text-[10px] text-slate-700 mt-2 font-bold uppercase tracking-tighter" }, "Use commas to separate days (1-31)", -1))
        ]),
        w("section", null, [
          m[6] || (m[6] = w("div", { class: "flex items-center gap-2 mb-4" }, [
            w("span", { class: "bg-slate-700 text-white text-[10px] px-2 py-0.5 font-black" }, "TYPE 1"),
            w("h4", { class: "text-xs font-black text-slate-700 uppercase tracking-widest" }, "Specific Dates (MMDD)")
          ], -1)),
          qe(w("input", {
            "onUpdate:modelValue": m[1] || (m[1] = (x) => i.value = x),
            placeholder: "Ex: 0101, 1225",
            class: "w-full bg-slate-100 border-l-4 border-slate-700 p-4 font-black text-slate-700 outline-none focus:bg-white transition-colors"
          }, null, 512), [
            [pt, i.value]
          ]),
          m[7] || (m[7] = w("p", { class: "text-[10px] text-slate-700 mt-2 font-bold uppercase tracking-tighter" }, "Use commas to separate dates (MonthDay format)", -1))
        ])
      ]))
    ]));
  }
}), Xa = { class: "p-8 space-y-12 max-w-4xl" }, za = { class: "bg-white p-8 border-2 border-slate-700" }, Ja = { class: "p-8" }, Za = { class: "max-w-5xl mx-auto" }, Qa = {
  key: 0,
  class: "fixed bottom-8 right-8 bg-red-600 text-white px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-3"
}, ei = /* @__PURE__ */ ft({
  __name: "BookingConfigPage",
  props: {
    bookingApi: {},
    bookingTimeApi: {},
    holidayApi: {}
  },
  setup(e) {
    const t = e, {
      configs: n,
      // 重命名為時間配置
      loading: o,
      isSaving: s,
      loadConfigs: r,
      updateConfigs: a
    } = ia(t.bookingTimeApi), { configs: i, isLoading: l, error: f, fetchConfigs: h, saveConfig: b } = aa(t.bookingApi);
    J(!1), Cs({
      id: void 0,
      merchant_id: "",
      // 提交前會由後端或 Service 補上
      table_number: 1,
      zone_id: 1,
      min_people: 2,
      max_people: 4
    }), Nn(async () => {
      await h(), await r(), await x();
    });
    const {
      holidayData: m,
      loadHolidays: x
    } = la(t.holidayApi), N = J(!1), p = J(!1), k = async (d) => {
      p.value = !0;
      try {
        await t.holidayApi.saveHolidays(d), m.value = d;
      } finally {
        p.value = !1;
      }
    };
    return (d, v) => (H(), Y(Ce, null, [
      w("div", Xa, [
        w("div", za, [
          Tt(qa, {
            holidayData: ie(m),
            loading: N.value,
            isSaving: p.value,
            onSave: k
          }, null, 8, ["holidayData", "loading", "isSaving"])
        ])
      ]),
      w("div", Ja, [
        Tt(_a, {
          configs: ie(n),
          loading: ie(o),
          isSaving: ie(s),
          onSave: ie(a)
        }, null, 8, ["configs", "loading", "isSaving", "onSave"])
      ]),
      w("div", Za, [
        Tt(Ba, {
          configs: ie(i),
          loading: ie(l),
          onRefresh: ie(h),
          onSave: ie(b)
        }, null, 8, ["configs", "loading", "onRefresh", "onSave"]),
        Tt(io, { name: "fade" }, {
          default: lo(() => [
            ie(f) ? (H(), Y("div", Qa, [
              w("span", null, "⚠️ " + X(ie(f)), 1),
              w("button", {
                onClick: v[0] || (v[0] = (T) => f.value = null),
                class: "bg-white/20 rounded-full w-6 h-6"
              }, "✕")
            ])) : $e("", !0)
          ]),
          _: 1
        })
      ])
    ], 64));
  }
}), co = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, s] of t)
    n[o] = s;
  return n;
}, mm = /* @__PURE__ */ co(ei, [["__scopeId", "data-v-40890156"]]);
var uo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ts(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ls = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(uo, function() {
    var n = 1e3, o = 6e4, s = 36e5, r = "millisecond", a = "second", i = "minute", l = "hour", f = "day", h = "week", b = "month", m = "quarter", x = "year", N = "date", p = "Invalid Date", k = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, d = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, v = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(I) {
      var S = ["th", "st", "nd", "rd"], D = I % 100;
      return "[" + I + (S[(D - 20) % 10] || S[D] || S[0]) + "]";
    } }, T = function(I, S, D) {
      var F = String(I);
      return !F || F.length >= S ? I : "" + Array(S + 1 - F.length).join(D) + I;
    }, y = { s: T, z: function(I) {
      var S = -I.utcOffset(), D = Math.abs(S), F = Math.floor(D / 60), P = D % 60;
      return (S <= 0 ? "+" : "-") + T(F, 2, "0") + ":" + T(P, 2, "0");
    }, m: function I(S, D) {
      if (S.date() < D.date()) return -I(D, S);
      var F = 12 * (D.year() - S.year()) + (D.month() - S.month()), P = S.clone().add(F, b), q = D - P < 0, B = S.clone().add(F + (q ? -1 : 1), b);
      return +(-(F + (D - P) / (q ? P - B : B - P)) || 0);
    }, a: function(I) {
      return I < 0 ? Math.ceil(I) || 0 : Math.floor(I);
    }, p: function(I) {
      return { M: b, y: x, w: h, d: f, D: N, h: l, m: i, s: a, ms: r, Q: m }[I] || String(I || "").toLowerCase().replace(/s$/, "");
    }, u: function(I) {
      return I === void 0;
    } }, A = "en", O = {};
    O[A] = v;
    var E = "$isDayjsObject", G = function(I) {
      return I instanceof U || !(!I || !I[E]);
    }, j = function I(S, D, F) {
      var P;
      if (!S) return A;
      if (typeof S == "string") {
        var q = S.toLowerCase();
        O[q] && (P = q), D && (O[q] = D, P = q);
        var B = S.split("-");
        if (!P && B.length > 1) return I(B[0]);
      } else {
        var Q = S.name;
        O[Q] = S, P = Q;
      }
      return !F && P && (A = P), P || !F && A;
    }, V = function(I, S) {
      if (G(I)) return I.clone();
      var D = typeof S == "object" ? S : {};
      return D.date = I, D.args = arguments, new U(D);
    }, K = y;
    K.l = j, K.i = G, K.w = function(I, S) {
      return V(I, { locale: S.$L, utc: S.$u, x: S.$x, $offset: S.$offset });
    };
    var U = function() {
      function I(D) {
        this.$L = j(D.locale, null, !0), this.parse(D), this.$x = this.$x || D.x || {}, this[E] = !0;
      }
      var S = I.prototype;
      return S.parse = function(D) {
        this.$d = function(F) {
          var P = F.date, q = F.utc;
          if (P === null) return /* @__PURE__ */ new Date(NaN);
          if (K.u(P)) return /* @__PURE__ */ new Date();
          if (P instanceof Date) return new Date(P);
          if (typeof P == "string" && !/Z$/i.test(P)) {
            var B = P.match(k);
            if (B) {
              var Q = B[2] - 1 || 0, le = (B[7] || "0").substring(0, 3);
              return q ? new Date(Date.UTC(B[1], Q, B[3] || 1, B[4] || 0, B[5] || 0, B[6] || 0, le)) : new Date(B[1], Q, B[3] || 1, B[4] || 0, B[5] || 0, B[6] || 0, le);
            }
          }
          return new Date(P);
        }(D), this.init();
      }, S.init = function() {
        var D = this.$d;
        this.$y = D.getFullYear(), this.$M = D.getMonth(), this.$D = D.getDate(), this.$W = D.getDay(), this.$H = D.getHours(), this.$m = D.getMinutes(), this.$s = D.getSeconds(), this.$ms = D.getMilliseconds();
      }, S.$utils = function() {
        return K;
      }, S.isValid = function() {
        return this.$d.toString() !== p;
      }, S.isSame = function(D, F) {
        var P = V(D);
        return this.startOf(F) <= P && P <= this.endOf(F);
      }, S.isAfter = function(D, F) {
        return V(D) < this.startOf(F);
      }, S.isBefore = function(D, F) {
        return this.endOf(F) < V(D);
      }, S.$g = function(D, F, P) {
        return K.u(D) ? this[F] : this.set(P, D);
      }, S.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, S.valueOf = function() {
        return this.$d.getTime();
      }, S.startOf = function(D, F) {
        var P = this, q = !!K.u(F) || F, B = K.p(D), Q = function(Ge, ve) {
          var Be = K.w(P.$u ? Date.UTC(P.$y, ve, Ge) : new Date(P.$y, ve, Ge), P);
          return q ? Be : Be.endOf(f);
        }, le = function(Ge, ve) {
          return K.w(P.toDate()[Ge].apply(P.toDate("s"), (q ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ve)), P);
        }, de = this.$W, be = this.$M, Te = this.$D, st = "set" + (this.$u ? "UTC" : "");
        switch (B) {
          case x:
            return q ? Q(1, 0) : Q(31, 11);
          case b:
            return q ? Q(1, be) : Q(0, be + 1);
          case h:
            var We = this.$locale().weekStart || 0, ze = (de < We ? de + 7 : de) - We;
            return Q(q ? Te - ze : Te + (6 - ze), be);
          case f:
          case N:
            return le(st + "Hours", 0);
          case l:
            return le(st + "Minutes", 1);
          case i:
            return le(st + "Seconds", 2);
          case a:
            return le(st + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, S.endOf = function(D) {
        return this.startOf(D, !1);
      }, S.$set = function(D, F) {
        var P, q = K.p(D), B = "set" + (this.$u ? "UTC" : ""), Q = (P = {}, P[f] = B + "Date", P[N] = B + "Date", P[b] = B + "Month", P[x] = B + "FullYear", P[l] = B + "Hours", P[i] = B + "Minutes", P[a] = B + "Seconds", P[r] = B + "Milliseconds", P)[q], le = q === f ? this.$D + (F - this.$W) : F;
        if (q === b || q === x) {
          var de = this.clone().set(N, 1);
          de.$d[Q](le), de.init(), this.$d = de.set(N, Math.min(this.$D, de.daysInMonth())).$d;
        } else Q && this.$d[Q](le);
        return this.init(), this;
      }, S.set = function(D, F) {
        return this.clone().$set(D, F);
      }, S.get = function(D) {
        return this[K.p(D)]();
      }, S.add = function(D, F) {
        var P, q = this;
        D = Number(D);
        var B = K.p(F), Q = function(be) {
          var Te = V(q);
          return K.w(Te.date(Te.date() + Math.round(be * D)), q);
        };
        if (B === b) return this.set(b, this.$M + D);
        if (B === x) return this.set(x, this.$y + D);
        if (B === f) return Q(1);
        if (B === h) return Q(7);
        var le = (P = {}, P[i] = o, P[l] = s, P[a] = n, P)[B] || 1, de = this.$d.getTime() + D * le;
        return K.w(de, this);
      }, S.subtract = function(D, F) {
        return this.add(-1 * D, F);
      }, S.format = function(D) {
        var F = this, P = this.$locale();
        if (!this.isValid()) return P.invalidDate || p;
        var q = D || "YYYY-MM-DDTHH:mm:ssZ", B = K.z(this), Q = this.$H, le = this.$m, de = this.$M, be = P.weekdays, Te = P.months, st = P.meridiem, We = function(ve, Be, rt, Je) {
          return ve && (ve[Be] || ve(F, q)) || rt[Be].slice(0, Je);
        }, ze = function(ve) {
          return K.s(Q % 12 || 12, ve, "0");
        }, Ge = st || function(ve, Be, rt) {
          var Je = ve < 12 ? "AM" : "PM";
          return rt ? Je.toLowerCase() : Je;
        };
        return q.replace(d, function(ve, Be) {
          return Be || function(rt) {
            switch (rt) {
              case "YY":
                return String(F.$y).slice(-2);
              case "YYYY":
                return K.s(F.$y, 4, "0");
              case "M":
                return de + 1;
              case "MM":
                return K.s(de + 1, 2, "0");
              case "MMM":
                return We(P.monthsShort, de, Te, 3);
              case "MMMM":
                return We(Te, de);
              case "D":
                return F.$D;
              case "DD":
                return K.s(F.$D, 2, "0");
              case "d":
                return String(F.$W);
              case "dd":
                return We(P.weekdaysMin, F.$W, be, 2);
              case "ddd":
                return We(P.weekdaysShort, F.$W, be, 3);
              case "dddd":
                return be[F.$W];
              case "H":
                return String(Q);
              case "HH":
                return K.s(Q, 2, "0");
              case "h":
                return ze(1);
              case "hh":
                return ze(2);
              case "a":
                return Ge(Q, le, !0);
              case "A":
                return Ge(Q, le, !1);
              case "m":
                return String(le);
              case "mm":
                return K.s(le, 2, "0");
              case "s":
                return String(F.$s);
              case "ss":
                return K.s(F.$s, 2, "0");
              case "SSS":
                return K.s(F.$ms, 3, "0");
              case "Z":
                return B;
            }
            return null;
          }(ve) || B.replace(":", "");
        });
      }, S.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, S.diff = function(D, F, P) {
        var q, B = this, Q = K.p(F), le = V(D), de = (le.utcOffset() - this.utcOffset()) * o, be = this - le, Te = function() {
          return K.m(B, le);
        };
        switch (Q) {
          case x:
            q = Te() / 12;
            break;
          case b:
            q = Te();
            break;
          case m:
            q = Te() / 3;
            break;
          case h:
            q = (be - de) / 6048e5;
            break;
          case f:
            q = (be - de) / 864e5;
            break;
          case l:
            q = be / s;
            break;
          case i:
            q = be / o;
            break;
          case a:
            q = be / n;
            break;
          default:
            q = be;
        }
        return P ? q : K.a(q);
      }, S.daysInMonth = function() {
        return this.endOf(b).$D;
      }, S.$locale = function() {
        return O[this.$L];
      }, S.locale = function(D, F) {
        if (!D) return this.$L;
        var P = this.clone(), q = j(D, F, !0);
        return q && (P.$L = q), P;
      }, S.clone = function() {
        return K.w(this.$d, this);
      }, S.toDate = function() {
        return new Date(this.valueOf());
      }, S.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, S.toISOString = function() {
        return this.$d.toISOString();
      }, S.toString = function() {
        return this.$d.toUTCString();
      }, I;
    }(), z = U.prototype;
    return V.prototype = z, [["$ms", r], ["$s", a], ["$m", i], ["$H", l], ["$W", f], ["$M", b], ["$y", x], ["$D", N]].forEach(function(I) {
      z[I[1]] = function(S) {
        return this.$g(S, I[0], I[1]);
      };
    }), V.extend = function(I, S) {
      return I.$i || (I(S, U, V), I.$i = !0), V;
    }, V.locale = j, V.isDayjs = G, V.unix = function(I) {
      return V(1e3 * I);
    }, V.en = O[A], V.Ls = O, V.p = {}, V;
  });
})(Ls);
var Ns = Ls.exports;
const it = /* @__PURE__ */ Ts(Ns);
var ti = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o(Ns);
  })(uo, function(n) {
    function o(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    var s = o(n), r = { name: "zh-tw", weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"), weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"), weekdaysMin: "日_一_二_三_四_五_六".split("_"), months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(a, i) {
      return i === "W" ? a + "週" : a + "日";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日 HH:mm", LLLL: "YYYY年M月D日dddd HH:mm", l: "YYYY/M/D", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日dddd HH:mm" }, relativeTime: { future: "%s內", past: "%s前", s: "幾秒", m: "1 分鐘", mm: "%d 分鐘", h: "1 小時", hh: "%d 小時", d: "1 天", dd: "%d 天", M: "1 個月", MM: "%d 個月", y: "1 年", yy: "%d 年" }, meridiem: function(a, i) {
      var l = 100 * a + i;
      return l < 600 ? "凌晨" : l < 900 ? "早上" : l < 1100 ? "上午" : l < 1300 ? "中午" : l < 1800 ? "下午" : "晚上";
    } };
    return s.default.locale(r, null, !0), r;
  });
})(ti);
var As = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(uo, function() {
    var n = "minute", o = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
    return function(r, a, i) {
      var l = a.prototype;
      i.utc = function(p) {
        var k = { date: p, utc: !0, args: arguments };
        return new a(k);
      }, l.utc = function(p) {
        var k = i(this.toDate(), { locale: this.$L, utc: !0 });
        return p ? k.add(this.utcOffset(), n) : k;
      }, l.local = function() {
        return i(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var f = l.parse;
      l.parse = function(p) {
        p.utc && (this.$u = !0), this.$utils().u(p.$offset) || (this.$offset = p.$offset), f.call(this, p);
      };
      var h = l.init;
      l.init = function() {
        if (this.$u) {
          var p = this.$d;
          this.$y = p.getUTCFullYear(), this.$M = p.getUTCMonth(), this.$D = p.getUTCDate(), this.$W = p.getUTCDay(), this.$H = p.getUTCHours(), this.$m = p.getUTCMinutes(), this.$s = p.getUTCSeconds(), this.$ms = p.getUTCMilliseconds();
        } else h.call(this);
      };
      var b = l.utcOffset;
      l.utcOffset = function(p, k) {
        var d = this.$utils().u;
        if (d(p)) return this.$u ? 0 : d(this.$offset) ? b.call(this) : this.$offset;
        if (typeof p == "string" && (p = function(A) {
          A === void 0 && (A = "");
          var O = A.match(o);
          if (!O) return null;
          var E = ("" + O[0]).match(s) || ["-", 0, 0], G = E[0], j = 60 * +E[1] + +E[2];
          return j === 0 ? 0 : G === "+" ? j : -j;
        }(p), p === null)) return this;
        var v = Math.abs(p) <= 16 ? 60 * p : p;
        if (v === 0) return this.utc(k);
        var T = this.clone();
        if (k) return T.$offset = v, T.$u = !1, T;
        var y = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (T = this.local().add(v + y, n)).$offset = v, T.$x.$localOffset = y, T;
      };
      var m = l.format;
      l.format = function(p) {
        var k = p || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return m.call(this, k);
      }, l.valueOf = function() {
        var p = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * p;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var x = l.toDate;
      l.toDate = function(p) {
        return p === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : x.call(this);
      };
      var N = l.diff;
      l.diff = function(p, k, d) {
        if (p && this.$u === p.$u) return N.call(this, p, k, d);
        var v = this.local(), T = i(p).local();
        return N.call(v, T, k, d);
      };
    };
  });
})(As);
var ni = As.exports;
const oi = /* @__PURE__ */ Ts(ni);
/*!
* sweetalert2 v11.26.25
* Released under the MIT License.
*/
function Os(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function si(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Fo(e, t) {
  return e.get(Os(e, t));
}
function ri(e, t, n) {
  si(e, t), t.set(e, n);
}
function ai(e, t, n) {
  return e.set(Os(e, t), n), n;
}
const ii = 100, R = {}, li = () => {
  R.previousActiveElement instanceof HTMLElement ? (R.previousActiveElement.focus(), R.previousActiveElement = null) : document.body && document.body.focus();
}, ci = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  R.restoreFocusTimeout = setTimeout(() => {
    li(), t();
  }, ii), window.scrollTo(n, o);
}), Is = "swal2-", ui = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], g = ui.reduce(
  (e, t) => (e[t] = Is + t, e),
  /** @type {SwalClasses} */
  {}
), di = ["success", "warning", "info", "question", "error"], wn = di.reduce(
  (e, t) => (e[t] = Is + t, e),
  /** @type {SwalIcons} */
  {}
), Ss = "SweetAlert2:", fo = (e) => e.charAt(0).toUpperCase() + e.slice(1), Ie = (e) => {
  console.warn(`${Ss} ${typeof e == "object" ? e.join(" ") : e}`);
}, St = (e) => {
  console.error(`${Ss} ${e}`);
}, Uo = [], fi = (e) => {
  Uo.includes(e) || (Uo.push(e), Ie(e));
}, Ds = (e, t = null) => {
  fi(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, An = (e) => typeof e == "function" ? e() : e, mo = (e) => e && typeof e.toPromise == "function", on = (e) => mo(e) ? e.toPromise() : Promise.resolve(e), po = (e) => e && Promise.resolve(e) === e, mi = () => navigator.userAgent.includes("Firefox"), Se = () => document.body.querySelector(`.${g.container}`), sn = (e) => {
  const t = Se();
  return t ? t.querySelector(e) : null;
}, Fe = (e) => sn(`.${e}`), oe = () => Fe(g.popup), Yt = () => Fe(g.icon), pi = () => Fe(g["icon-content"]), Ps = () => Fe(g.title), ho = () => Fe(g["html-container"]), $s = () => Fe(g.image), wo = () => Fe(g["progress-steps"]), On = () => Fe(g["validation-message"]), nt = () => (
  /** @type {HTMLButtonElement} */
  sn(`.${g.actions} .${g.confirm}`)
), jt = () => (
  /** @type {HTMLButtonElement} */
  sn(`.${g.actions} .${g.cancel}`)
), Dt = () => (
  /** @type {HTMLButtonElement} */
  sn(`.${g.actions} .${g.deny}`)
), hi = () => Fe(g["input-label"]), Wt = () => sn(`.${g.loader}`), rn = () => Fe(g.actions), Ms = () => Fe(g.footer), In = () => Fe(g["timer-progress-bar"]), go = () => Fe(g.close), wi = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, bo = () => {
  const e = oe();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((r, a) => {
    const i = parseInt(r.getAttribute("tabindex") || "0"), l = parseInt(a.getAttribute("tabindex") || "0");
    return i > l ? 1 : i < l ? -1 : 0;
  }), o = e.querySelectorAll(wi), s = Array.from(o).filter((r) => r.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(s))].filter((r) => De(r));
}, vo = () => ct(document.body, g.shown) && !ct(document.body, g["toast-shown"]) && !ct(document.body, g["no-backdrop"]), Sn = () => {
  const e = oe();
  return e ? ct(e, g.toast) : !1;
}, gi = () => {
  const e = oe();
  return e ? e.hasAttribute("data-loading") : !1;
}, Ue = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), s = o.querySelector("head");
    s && Array.from(s.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const r = o.querySelector("body");
    r && Array.from(r.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, ct = (e, t) => t ? t.split(/\s+/).every((n) => e.classList.contains(n)) : !1, bi = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(g).includes(n) && !Object.values(wn).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, Re = (e, t, n) => {
  if (bi(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Ie(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    ne(e, o);
  }
}, Dn = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${g.popup} > .${g[t]}`);
    case "checkbox":
      return e.querySelector(`.${g.popup} > .${g.checkbox} input`);
    case "radio":
      return e.querySelector(`.${g.popup} > .${g.radio} input:checked`) || e.querySelector(`.${g.popup} > .${g.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${g.popup} > .${g.range} input`);
    default:
      return e.querySelector(`.${g.popup} > .${g.input}`);
  }
}, Rs = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Fs = (e, t, n) => {
  if (!e || !t)
    return;
  const o = typeof t == "string" ? t.split(/\s+/).filter(Boolean) : t;
  (Array.isArray(e) ? e : [e]).forEach((r) => {
    o.forEach((a) => {
      n ? r.classList.add(a) : r.classList.remove(a);
    });
  });
}, ne = (e, t) => {
  Fs(e, t, !0);
}, je = (e, t) => {
  Fs(e, t, !1);
}, ht = (e, t) => (
  /** @type {HTMLElement | undefined} */
  Array.from(e.children).find((n) => n instanceof HTMLElement && ct(n, t))
), At = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || n === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, xe = (e, t = "flex") => {
  e && (e.style.display = t);
}, Ae = (e) => {
  e && (e.style.display = "none");
}, _o = (e, t = "block") => {
  e && new MutationObserver(() => {
    an(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, Bo = (e, t, n, o) => {
  const s = e.querySelector(t);
  s && s.style.setProperty(n, o);
}, an = (e, t, n = "flex") => {
  t ? xe(e, n) : Ae(e);
}, De = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), vi = () => !De(nt()) && !De(Dt()) && !De(jt()), qn = (e) => e.scrollHeight > e.clientHeight, _i = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (qn(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, Us = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, yo = (e, t = !1) => {
  const n = In();
  n && De(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, yi = () => {
  const e = In();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, Ei = () => typeof window > "u" || typeof document > "u", ki = `
 <div aria-labelledby="${g.title}" aria-describedby="${g["html-container"]}" class="${g.popup}" tabindex="-1">
   <button type="button" class="${g.close}"></button>
   <ul class="${g["progress-steps"]}"></ul>
   <div class="${g.icon}"></div>
   <img class="${g.image}" />
   <h2 class="${g.title}" id="${g.title}"></h2>
   <div class="${g["html-container"]}" id="${g["html-container"]}"></div>
   <input class="${g.input}" id="${g.input}" />
   <input type="file" class="${g.file}" />
   <div class="${g.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${g.select}" id="${g.select}"></select>
   <div class="${g.radio}"></div>
   <label class="${g.checkbox}">
     <input type="checkbox" id="${g.checkbox}" />
     <span class="${g.label}"></span>
   </label>
   <textarea class="${g.textarea}" id="${g.textarea}"></textarea>
   <div class="${g["validation-message"]}" id="${g["validation-message"]}"></div>
   <div class="${g.actions}">
     <div class="${g.loader}"></div>
     <button type="button" class="${g.confirm}"></button>
     <button type="button" class="${g.deny}"></button>
     <button type="button" class="${g.cancel}"></button>
   </div>
   <div class="${g.footer}"></div>
   <div class="${g["timer-progress-bar-container"]}">
     <div class="${g["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), xi = () => {
  const e = Se();
  return e ? (e.remove(), je([document.documentElement, document.body], [
    g["no-backdrop"],
    g["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    g["has-column"]
  ]), !0) : !1;
}, Ct = () => {
  R.currentInstance && R.currentInstance.resetValidationMessage();
}, Ci = () => {
  const e = oe();
  if (!e)
    return;
  const t = ht(e, g.input), n = ht(e, g.file), o = e.querySelector(`.${g.range} input`), s = e.querySelector(`.${g.range} output`), r = ht(e, g.select), a = e.querySelector(`.${g.checkbox} input`), i = ht(e, g.textarea);
  t && (t.oninput = Ct), n && (n.onchange = Ct), r && (r.onchange = Ct), a && (a.onchange = Ct), i && (i.oninput = Ct), o && s && (o.oninput = () => {
    Ct(), s.value = o.value;
  }, o.onchange = () => {
    Ct(), s.value = o.value;
  });
}, Ti = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, Li = (e) => {
  const t = oe();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, Ni = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (ne(Se(), g.rtl), R.isRTL = !0);
}, Ai = (e) => {
  const t = xi();
  if (Ei()) {
    St("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = g.container, t && ne(n, g["no-transition"]), Ue(n, ki), n.dataset.swal2Theme = e.theme;
  const o = Ti(e.target || "body");
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), Li(e), Ni(o), Ci();
}, Eo = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? Oi(e, t) : e && Ue(t, e);
}, Oi = (e, t) => {
  "jquery" in e ? Ii(t, e) : Ue(t, e.toString());
}, Ii = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, Si = (e, t) => {
  const n = rn(), o = Wt();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? Ae(n) : xe(n), Re(n, t, "actions"), Di(n, o, t), Ue(o, t.loaderHtml || ""), Re(o, t, "loader"));
};
function Di(e, t, n) {
  const o = nt(), s = Dt(), r = jt();
  !o || !s || !r || (Vn(o, "confirm", n), Vn(s, "deny", n), Vn(r, "cancel", n), Pi(o, s, r, n), n.reverseButtons && (n.toast ? (e.insertBefore(r, o), e.insertBefore(s, o)) : (e.insertBefore(r, t), e.insertBefore(s, t), e.insertBefore(o, t))));
}
function Pi(e, t, n, o) {
  if (!o.buttonsStyling) {
    je([e, t, n], g.styled);
    return;
  }
  ne([e, t, n], g.styled), [[e, "confirm", o.confirmButtonColor], [t, "deny", o.denyButtonColor], [n, "cancel", o.cancelButtonColor]].forEach(([r, a, i]) => {
    i && r.style.setProperty(`--swal2-${a}-button-background-color`, i), $i(r);
  });
}
function $i(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Vn(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    fo(t)
  );
  an(e, n[`show${o}Button`], "inline-block"), Ue(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = g[t], Re(e, n, `${t}Button`);
}
const Mi = (e, t) => {
  const n = go();
  n && (Ue(n, t.closeButtonHtml || ""), Re(n, t, "closeButton"), an(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, Ri = (e, t) => {
  const n = Se();
  n && (Fi(n, t.backdrop), Ui(n, t.position), Bi(n, t.grow), Re(n, t, "container"));
};
function Fi(e, t) {
  typeof t == "string" ? e.style.background = t : t || ne([document.documentElement, document.body], g["no-backdrop"]);
}
function Ui(e, t) {
  t && (t in g ? ne(e, g[t]) : (Ie('The "position" parameter is not valid, defaulting to "center"'), ne(e, g.center)));
}
function Bi(e, t) {
  t && ne(e, g[`grow-${t}`]);
}
var re = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap(),
  focusedElement: /* @__PURE__ */ new WeakMap()
};
const Vi = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], Hi = (e, t) => {
  const n = oe();
  if (!n)
    return;
  const o = re.innerParams.get(e), s = !o || t.input !== o.input;
  Vi.forEach((r) => {
    const a = ht(n, g[r]);
    a && (Wi(r, t.inputAttributes), a.className = g[r], s && Ae(a));
  }), t.input && (s && Yi(t), Gi(t));
}, Yi = (e) => {
  if (!e.input)
    return;
  if (!pe[e.input]) {
    St(`Unexpected type of input! Expected ${Object.keys(pe).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Bs(e.input);
  if (!t)
    return;
  const n = pe[e.input](t, e);
  xe(t), e.inputAutoFocus && setTimeout(() => {
    Rs(n);
  });
}, ji = (e) => {
  for (const {
    name: t
  } of Array.from(e.attributes))
    ["id", "type", "value", "style"].includes(t) || e.removeAttribute(t);
}, Wi = (e, t) => {
  const n = oe();
  if (!n)
    return;
  const o = Dn(n, e);
  if (o) {
    ji(o);
    for (const s in t)
      o.setAttribute(s, t[s]);
  }
}, Gi = (e) => {
  if (!e.input)
    return;
  const t = Bs(e.input);
  t && Re(t, e, "input");
}, ko = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, ln = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), s = g["input-label"];
    o.setAttribute("for", e.id), o.className = s, typeof n.customClass == "object" && ne(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, Bs = (e) => {
  const t = oe();
  if (t)
    return ht(t, g[
      /** @type {SwalClass} */
      e
    ] || g.input);
}, gn = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : po(t) || Ie(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, pe = {};
pe.text = pe.email = pe.password = pe.number = pe.tel = pe.url = pe.search = pe.date = pe["datetime-local"] = pe.time = pe.week = pe.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return gn(n, t.inputValue), ln(n, n, t), ko(n, t), n.type = /** @type {string} */
  t.input, n;
};
pe.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return ln(n, n, t), ko(n, t), n;
};
pe.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), o = n.querySelector("input"), s = n.querySelector("output");
  return o && (gn(o, t.inputValue), o.type = /** @type {string} */
  t.input, ln(
    o,
    /** @type {Input} */
    e,
    t
  )), s && gn(s, t.inputValue), /** @type {Input} */
  e;
};
pe.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    Ue(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, n.appendChild(o);
  }
  return ln(n, n, t), n;
};
pe.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
pe.checkbox = (e, t) => {
  const n = oe();
  if (!n)
    throw new Error("Popup not found");
  const o = Dn(n, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const r = /** @type {HTMLElement} */ e.querySelector("span");
  if (r) {
    const a = t.inputPlaceholder || t.inputLabel;
    a && Ue(r, a);
  }
  return o;
};
pe.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  gn(n, t.inputValue), ko(n, t), ln(n, n, t);
  const o = (s) => parseInt(window.getComputedStyle(s).marginLeft) + parseInt(window.getComputedStyle(s).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const s = oe();
      if (!s)
        return;
      const r = parseInt(window.getComputedStyle(s).width), a = () => {
        if (!document.body.contains(n))
          return;
        const i = n.offsetWidth + o(n), l = oe();
        l && (i > r ? l.style.width = `${i}px` : At(l, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const Ki = (e, t) => {
  const n = ho();
  n && (_o(n), Re(n, t, "htmlContainer"), t.html ? (Eo(t.html, n), xe(n, "block")) : t.text ? (n.textContent = t.text, xe(n, "block")) : Ae(n), Hi(e, t));
}, qi = (e, t) => {
  const n = Ms();
  n && (_o(n), an(n, !!t.footer, "block"), t.footer && Eo(t.footer, n), Re(n, t, "footer"));
}, Xi = (e, t) => {
  const n = re.innerParams.get(e), o = Yt();
  if (!o)
    return;
  if (n && t.icon === n.icon) {
    Ho(o, t), Vo(o, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    Ae(o);
    return;
  }
  if (t.icon && Object.keys(wn).indexOf(t.icon) === -1) {
    St(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), Ae(o);
    return;
  }
  xe(o), Ho(o, t), Vo(o, t), ne(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Vs);
}, Vo = (e, t) => {
  for (const [n, o] of Object.entries(wn))
    t.icon !== n && je(e, o);
  ne(e, t.icon && wn[t.icon]), Zi(e, t), Vs(), Re(e, t, "icon");
}, Vs = () => {
  const e = oe();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color");
  e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix").forEach((o) => {
    o.style.backgroundColor = t;
  });
}, zi = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, Ji = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, Ho = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = Yo(t.iconHtml) : t.icon === "success" ? (o = zi(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = Ji : t.icon && (o = Yo({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && Ue(e, o);
}, Zi = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      Bo(e, n, "background-color", t.iconColor);
    Bo(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, Yo = (e) => `<div class="${g["icon-content"]}">${e}</div>`, Qi = (e, t) => {
  const n = $s();
  if (n) {
    if (!t.imageUrl) {
      Ae(n);
      return;
    }
    xe(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), At(n, "width", t.imageWidth), At(n, "height", t.imageHeight), n.className = g.image, Re(n, t, "image");
  }
};
let xo = !1, Hs = 0, Ys = 0, js = 0, Ws = 0;
const el = (e) => {
  e.addEventListener("mousedown", bn), document.body.addEventListener("mousemove", vn), e.addEventListener("mouseup", _n), e.addEventListener("touchstart", bn), document.body.addEventListener("touchmove", vn), e.addEventListener("touchend", _n);
}, tl = (e) => {
  e.removeEventListener("mousedown", bn), document.body.removeEventListener("mousemove", vn), e.removeEventListener("mouseup", _n), e.removeEventListener("touchstart", bn), document.body.removeEventListener("touchmove", vn), e.removeEventListener("touchend", _n);
}, bn = (e) => {
  const t = oe();
  if (!t)
    return;
  const n = Yt();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    xo = !0;
    const o = Gs(e);
    Hs = o.clientX, Ys = o.clientY, js = parseInt(t.style.insetInlineStart) || 0, Ws = parseInt(t.style.insetBlockStart) || 0, ne(t, "swal2-dragging");
  }
}, vn = (e) => {
  const t = oe();
  if (t && xo) {
    let {
      clientX: n,
      clientY: o
    } = Gs(e);
    const s = n - Hs;
    t.style.insetInlineStart = `${js + (R.isRTL ? -s : s)}px`, t.style.insetBlockStart = `${Ws + (o - Ys)}px`;
  }
}, _n = () => {
  const e = oe();
  xo = !1, je(e, "swal2-dragging");
}, Gs = (e) => {
  const t = e.type.startsWith("touch") ? (
    /** @type {TouchEvent} */
    e.touches[0]
  ) : (
    /** @type {MouseEvent} */
    e
  );
  return {
    clientX: t.clientX,
    clientY: t.clientY
  };
}, nl = (e, t) => {
  const n = Se(), o = oe();
  if (!(!n || !o)) {
    if (t.toast) {
      At(n, "width", t.width), o.style.width = "100%";
      const s = Wt();
      s && o.insertBefore(s, Yt());
    } else
      At(o, "width", t.width);
    At(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), Ae(On()), ol(o, t), t.draggable && !t.toast ? (ne(o, g.draggable), el(o)) : (je(o, g.draggable), tl(o));
  }
}, ol = (e, t) => {
  const n = t.showClass || {};
  e.className = `${g.popup} ${De(e) ? n.popup : ""}`, t.toast ? (ne([document.documentElement, document.body], g["toast-shown"]), ne(e, g.toast)) : ne(e, g.modal), Re(e, t, "popup"), typeof t.customClass == "string" && ne(e, t.customClass), t.icon && ne(e, g[`icon-${t.icon}`]);
}, sl = (e, t) => {
  const n = wo();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: s
  } = t;
  if (!o || o.length === 0 || s === void 0) {
    Ae(n);
    return;
  }
  xe(n), n.textContent = "", s >= o.length && Ie("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((r, a) => {
    const i = rl(r);
    if (n.appendChild(i), a === s && ne(i, g["active-progress-step"]), a !== o.length - 1) {
      const l = al(t);
      n.appendChild(l);
    }
  });
}, rl = (e) => {
  const t = document.createElement("li");
  return ne(t, g["progress-step"]), Ue(t, e), t;
}, al = (e) => {
  const t = document.createElement("li");
  return ne(t, g["progress-step-line"]), e.progressStepsDistance && At(t, "width", e.progressStepsDistance), t;
}, il = (e, t) => {
  const n = Ps();
  n && (_o(n), an(n, !!(t.title || t.titleText), "block"), t.title && Eo(t.title, n), t.titleText && (n.innerText = t.titleText), Re(n, t, "title"));
}, Ks = (e, t) => {
  var n;
  nl(e, t), Ri(e, t), sl(e, t), Xi(e, t), Qi(e, t), il(e, t), Mi(e, t), Ki(e, t), Si(e, t), qi(e, t);
  const o = oe();
  typeof t.didRender == "function" && o && t.didRender(o), (n = R.eventEmitter) === null || n === void 0 || n.emit("didRender", o);
}, ll = () => De(oe()), qs = () => {
  var e;
  return (e = nt()) === null || e === void 0 ? void 0 : e.click();
}, cl = () => {
  var e;
  return (e = Dt()) === null || e === void 0 ? void 0 : e.click();
}, ul = () => {
  var e;
  return (e = jt()) === null || e === void 0 ? void 0 : e.click();
}, Gt = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), Xs = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, dl = (e, t, n) => {
  if (Xs(e), !t.toast) {
    const o = (r) => ml(t, r, n);
    e.keydownHandler = o;
    const s = t.keydownListenerCapture ? window : oe();
    if (s) {
      e.keydownTarget = s, e.keydownListenerCapture = t.keydownListenerCapture;
      const r = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", r, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, Xn = (e, t) => {
  var n;
  const o = bo();
  return o.length ? (e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus(), !(mi() && o[e] instanceof HTMLIFrameElement)) : ((n = oe()) === null || n === void 0 || n.focus(), !0);
}, zs = ["ArrowRight", "ArrowDown"], fl = ["ArrowLeft", "ArrowUp"], ml = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? pl(t, e) : t.key === "Tab" ? hl(t) : [...zs, ...fl].includes(t.key) ? wl(t.key) : t.key === "Escape" && gl(t, e, n)));
}, pl = (e, t) => {
  if (!An(t.allowEnterKey))
    return;
  const n = oe();
  if (!n || !t.input)
    return;
  const o = Dn(n, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    qs(), e.preventDefault();
  }
}, hl = (e) => {
  const t = e.target, o = bo().findIndex((r) => r === t);
  let s = !0;
  e.shiftKey ? s = Xn(o, -1) : s = Xn(o, 1), e.stopPropagation(), s && e.preventDefault();
}, wl = (e) => {
  const t = rn(), n = nt(), o = Dt(), s = jt();
  if (!t || !n || !o || !s)
    return;
  const r = [n, o, s];
  if (document.activeElement instanceof HTMLElement && !r.includes(document.activeElement))
    return;
  const a = zs.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let l = 0; l < t.children.length; l++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && De(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, gl = (e, t, n) => {
  e.preventDefault(), An(t.allowEscapeKey) && n(Gt.esc);
};
var Ut = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const bl = () => {
  const e = Se();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, Js = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, Co = typeof window < "u" && !!window.GestureEvent, vl = Co && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, _l = () => {
  if (Co && !ct(document.body, g.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, ne(document.body, g.iosfix), yl();
  }
}, yl = () => {
  const e = Se();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = El(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, El = (e) => {
  const t = e.target, n = Se(), o = ho();
  return !n || !o || kl(e) || xl(e) ? !1 : t === n || !qn(n) && t instanceof HTMLElement && !_i(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(qn(o) && // #1944
  o.contains(t));
}, kl = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), xl = (e) => e.touches && e.touches.length > 1, Cl = () => {
  if (ct(document.body, g.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    je(document.body, g.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, Tl = () => {
  const e = document.createElement("div");
  e.className = g["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let Rt = null;
const Ll = (e) => {
  Rt === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (Rt = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${Rt + Tl()}px`);
}, Nl = () => {
  Rt !== null && (document.body.style.paddingRight = `${Rt}px`, Rt = null);
};
function Zs(e, t, n, o) {
  Sn() ? jo(e, o) : (ci(n).then(() => jo(e, o)), Xs(R)), Co ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), vo() && (Nl(), Cl(), Js()), Al();
}
function Al() {
  je([document.documentElement, document.body], [g.shown, g["height-auto"], g["no-backdrop"], g["toast-shown"]]);
}
function wt(e) {
  e = Il(e);
  const t = Ut.swalPromiseResolve.get(this), n = Ol(this);
  this.isAwaitingPromise ? e.isDismissed || (cn(this), t(e)) : n && t(e);
}
const Ol = (e) => {
  const t = oe();
  if (!t)
    return !1;
  const n = re.innerParams.get(e);
  if (!n || ct(t, n.hideClass.popup))
    return !1;
  je(t, n.showClass.popup), ne(t, n.hideClass.popup);
  const o = Se();
  return je(o, n.showClass.backdrop), ne(o, n.hideClass.backdrop), Sl(e, t, n), !0;
};
function Qs(e) {
  const t = Ut.swalPromiseReject.get(this);
  cn(this), t && t(e);
}
const cn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, re.innerParams.get(e) || e._destroy());
}, Il = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), Sl = (e, t, n) => {
  var o;
  const s = Se(), r = Us(t);
  typeof n.willClose == "function" && n.willClose(t), (o = R.eventEmitter) === null || o === void 0 || o.emit("willClose", t), r && s ? Dl(e, t, s, !!n.returnFocus, n.didClose) : s && Zs(e, s, !!n.returnFocus, n.didClose);
}, Dl = (e, t, n, o, s) => {
  R.swalCloseEventFinishedCallback = Zs.bind(null, e, n, o, s);
  const r = function(a) {
    if (a.target === t) {
      var i;
      (i = R.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(R), delete R.swalCloseEventFinishedCallback, t.removeEventListener("animationend", r), t.removeEventListener("transitionend", r);
    }
  };
  t.addEventListener("animationend", r), t.addEventListener("transitionend", r);
}, jo = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = R.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, Bt = (e) => {
  let t = oe();
  if (t || new Jt(), t = oe(), !t)
    return;
  const n = Wt();
  Sn() ? Ae(Yt()) : Pl(t, e), xe(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, Pl = (e, t) => {
  const n = rn(), o = Wt();
  !n || !o || (!t && De(nt()) && (t = nt()), xe(n), t && (Ae(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), ne([e, n], g.loading));
}, $l = (e, t) => {
  t.input === "select" || t.input === "radio" ? Bl(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (mo(t.inputValue) || po(t.inputValue)) && (Bt(nt()), Vl(e, t));
}, Ml = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return Rl(n);
    case "radio":
      return Fl(n);
    case "file":
      return Ul(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, Rl = (e) => e.checked ? 1 : 0, Fl = (e) => e.checked ? e.value : null, Ul = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, Bl = (e, t) => {
  const n = oe();
  if (!n)
    return;
  const o = (s) => {
    t.input === "select" ? Hl(n, zn(s), t) : t.input === "radio" && Yl(n, zn(s), t);
  };
  mo(t.inputOptions) || po(t.inputOptions) ? (Bt(nt()), on(t.inputOptions).then((s) => {
    e.hideLoading(), o(s);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : St(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Vl = (e, t) => {
  const n = e.getInput();
  n && (Ae(n), on(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, xe(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    St(`Error in inputValue promise: ${o}`), n.value = "", xe(n), n.focus(), e.hideLoading();
  }));
};
function Hl(e, t, n) {
  const o = ht(e, g.select);
  if (!o)
    return;
  const s = (r, a, i) => {
    const l = document.createElement("option");
    l.value = i, Ue(l, a), l.selected = er(i, n.inputValue), r.appendChild(l);
  };
  t.forEach((r) => {
    const a = r[0], i = r[1];
    if (Array.isArray(i)) {
      const l = document.createElement("optgroup");
      l.label = a, l.disabled = !1, o.appendChild(l), i.forEach((f) => s(l, f[1], f[0]));
    } else
      s(o, i, a);
  }), o.focus();
}
function Yl(e, t, n) {
  const o = ht(e, g.radio);
  if (!o)
    return;
  t.forEach((r) => {
    const a = r[0], i = r[1], l = document.createElement("input"), f = document.createElement("label");
    l.type = "radio", l.name = g.radio, l.value = a, er(a, n.inputValue) && (l.checked = !0);
    const h = document.createElement("span");
    Ue(h, i), h.className = g.label, f.appendChild(l), f.appendChild(h), o.appendChild(f);
  });
  const s = o.querySelectorAll("input");
  s.length && s[0].focus();
}
const zn = (e) => (e instanceof Map ? Array.from(e) : Object.entries(e)).map(([n, o]) => [n, typeof o == "object" ? zn(o) : o]), er = (e, t) => !!t && t != null && t.toString() === e.toString(), jl = (e) => {
  const t = re.innerParams.get(e);
  e.disableButtons(), t.input ? tr(e, "confirm") : Lo(e, !0);
}, Wl = (e) => {
  const t = re.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? tr(e, "deny") : To(e, !1);
}, Gl = (e, t) => {
  e.disableButtons(), t(Gt.cancel);
}, tr = (e, t) => {
  const n = re.innerParams.get(e);
  if (!n.input) {
    St(`The "input" parameter is needed to be set when using returnInputValueOn${fo(t)}`);
    return;
  }
  const o = e.getInput(), s = Ml(e, n);
  n.inputValidator ? Kl(e, s, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? To(e, s) : Lo(e, s);
}, Kl = (e, t, n) => {
  const o = re.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => on(o.inputValidator(t, o.validationMessage))).then((r) => {
    e.enableButtons(), e.enableInput(), r ? e.showValidationMessage(r) : n === "deny" ? To(e, t) : Lo(e, t);
  });
}, To = (e, t) => {
  const n = re.innerParams.get(e);
  n.showLoaderOnDeny && Bt(Dt()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => on(n.preDeny(t, n.validationMessage))).then((s) => {
    s === !1 ? (e.hideLoading(), cn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof s > "u" ? t : s
      }
    );
  }).catch((s) => nr(e, s))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, Wo = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, nr = (e, t) => {
  e.rejectPromise(t);
}, Lo = (e, t) => {
  const n = re.innerParams.get(e);
  n.showLoaderOnConfirm && Bt(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => on(n.preConfirm(t, n.validationMessage))).then((s) => {
    De(On()) || s === !1 ? (e.hideLoading(), cn(e)) : Wo(e, typeof s > "u" ? t : s);
  }).catch((s) => nr(e, s))) : Wo(e, t);
};
function yn() {
  const e = re.innerParams.get(this);
  if (!e)
    return;
  const t = re.domCache.get(this);
  Ae(t.loader), Sn() ? e.icon && xe(Yt()) : ql(t), je([t.popup, t.actions], g.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), this.enableButtons();
}
const ql = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? xe(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : vi() && Ae(e.actions);
};
function or() {
  const e = re.innerParams.get(this), t = re.domCache.get(this);
  return t ? Dn(t.popup, e.input) : null;
}
function sr(e, t, n) {
  const o = re.domCache.get(e);
  t.forEach((s) => {
    o[s].disabled = n;
  });
}
function rr(e, t) {
  const n = oe();
  !n || !e || (e.type === "radio" ? n.querySelectorAll(`[name="${g.radio}"]`).forEach((s) => {
    s.disabled = t;
  }) : e.disabled = t);
}
function ar() {
  sr(this, ["confirmButton", "denyButton", "cancelButton"], !1);
  const e = re.focusedElement.get(this);
  e instanceof HTMLElement && document.activeElement === document.body && e.focus(), re.focusedElement.delete(this);
}
function ir() {
  re.focusedElement.set(this, document.activeElement), sr(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function lr() {
  rr(this.getInput(), !1);
}
function cr() {
  rr(this.getInput(), !0);
}
function ur(e) {
  const t = re.domCache.get(this), n = re.innerParams.get(this);
  Ue(t.validationMessage, e), t.validationMessage.className = g["validation-message"], n.customClass && n.customClass.validationMessage && ne(t.validationMessage, n.customClass.validationMessage), xe(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", g["validation-message"]), Rs(o), ne(o, g.inputerror));
}
function dr() {
  const e = re.domCache.get(this);
  e.validationMessage && Ae(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), je(t, g.inputerror));
}
const gt = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, Xl = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], zl = {
  allowEnterKey: void 0
}, Jl = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], fr = (e) => Object.prototype.hasOwnProperty.call(gt, e), mr = (e) => Xl.indexOf(e) !== -1, pr = (e) => zl[e], Zl = (e) => {
  fr(e) || Ie(`Unknown parameter "${e}"`);
}, Ql = (e) => {
  Jl.includes(e) && Ie(`The parameter "${e}" is incompatible with toasts`);
}, ec = (e) => {
  const t = pr(e);
  t && Ds(e, t);
}, hr = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Ie('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Ie(`Invalid theme "${e.theme}"`);
  for (const t in e)
    Zl(t), e.toast && Ql(t), ec(t);
};
function wr(e) {
  const t = Se(), n = oe(), o = re.innerParams.get(this);
  if (!n || ct(n, o.hideClass.popup)) {
    Ie("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const s = tc(e), r = Object.assign({}, o, s);
  hr(r), t && (t.dataset.swal2Theme = r.theme), Ks(this, r), re.innerParams.set(this, r), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const tc = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (mr(n)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = o[n];
    } else
      Ie(`Invalid parameter to update: ${n}`);
  }), t;
};
function gr() {
  var e;
  const t = re.domCache.get(this), n = re.innerParams.get(this);
  if (!n) {
    br(this);
    return;
  }
  t.popup && R.swalCloseEventFinishedCallback && (R.swalCloseEventFinishedCallback(), delete R.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = R.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), nc(this);
}
const nc = (e) => {
  br(e), delete e.params, delete R.keydownHandler, delete R.keydownTarget, delete R.currentInstance;
}, br = (e) => {
  e.isAwaitingPromise ? (Hn(re, e), e.isAwaitingPromise = !0) : (Hn(Ut, e), Hn(re, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Hn = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var oc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: gr,
  close: wt,
  closeModal: wt,
  closePopup: wt,
  closeToast: wt,
  disableButtons: ir,
  disableInput: cr,
  disableLoading: yn,
  enableButtons: ar,
  enableInput: lr,
  getInput: or,
  handleAwaitingPromise: cn,
  hideLoading: yn,
  rejectPromise: Qs,
  resetValidationMessage: dr,
  showValidationMessage: ur,
  update: wr
});
const sc = (e, t, n) => {
  e.toast ? rc(e, t, n) : (ic(t), lc(t), cc(e, t, n));
}, rc = (e, t, n) => {
  t.popup.onclick = () => {
    e && (ac(e) || e.timer || e.input) || n(Gt.close);
  };
}, ac = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let En = !1;
const ic = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (En = !0);
    };
  };
}, lc = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (En = !0);
    };
  };
}, cc = (e, t, n) => {
  t.container.onclick = (o) => {
    if (En) {
      En = !1;
      return;
    }
    o.target === t.container && An(e.allowOutsideClick) && n(Gt.backdrop);
  };
}, uc = (e) => typeof e == "object" && e !== null && "jquery" in e, Go = (e) => e instanceof Element || uc(e), dc = (e) => {
  const t = {};
  return typeof e[0] == "object" && !Go(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const s = e[o];
    typeof s == "string" || Go(s) ? t[n] = s : s !== void 0 && St(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof s}`);
  }), /** @type {SweetAlertOptions} */
  t;
};
function fc(...e) {
  return new this(...e);
}
function mc(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, s) {
      return super._main(o, Object.assign({}, e, s));
    }
  }
  return t;
}
const pc = () => R.timeout && R.timeout.getTimerLeft(), vr = () => {
  if (R.timeout)
    return yi(), R.timeout.stop();
}, _r = () => {
  if (R.timeout) {
    const e = R.timeout.start();
    return yo(e), e;
  }
}, hc = () => {
  const e = R.timeout;
  return e && (e.running ? vr() : _r());
}, wc = (e) => {
  if (R.timeout) {
    const t = R.timeout.increase(e);
    return yo(t, !0), t;
  }
}, gc = () => !!(R.timeout && R.timeout.isRunning());
let Ko = !1;
const Jn = {};
function bc(e = "data-swal-template") {
  Jn[e] = this, Ko || (document.body.addEventListener("click", vc), Ko = !0);
}
const vc = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in Jn) {
      const o = t.getAttribute && t.getAttribute(n);
      if (o) {
        Jn[n].fire({
          template: o
        });
        return;
      }
    }
};
class _c {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...s) => {
      this.removeListener(t, o), n.apply(this, s);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (s) {
          console.error(s);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), s = o.indexOf(n);
    s > -1 && o.splice(s, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
R.eventEmitter = new _c();
const yc = (e, t) => {
  R.eventEmitter && R.eventEmitter.on(e, t);
}, Ec = (e, t) => {
  R.eventEmitter && R.eventEmitter.once(e, t);
}, kc = (e, t) => {
  if (R.eventEmitter) {
    if (!e) {
      R.eventEmitter.reset();
      return;
    }
    t ? R.eventEmitter.removeListener(e, t) : R.eventEmitter.removeAllListeners(e);
  }
};
var xc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: dc,
  bindClickHandler: bc,
  clickCancel: ul,
  clickConfirm: qs,
  clickDeny: cl,
  enableLoading: Bt,
  fire: fc,
  getActions: rn,
  getCancelButton: jt,
  getCloseButton: go,
  getConfirmButton: nt,
  getContainer: Se,
  getDenyButton: Dt,
  getFocusableElements: bo,
  getFooter: Ms,
  getHtmlContainer: ho,
  getIcon: Yt,
  getIconContent: pi,
  getImage: $s,
  getInputLabel: hi,
  getLoader: Wt,
  getPopup: oe,
  getProgressSteps: wo,
  getTimerLeft: pc,
  getTimerProgressBar: In,
  getTitle: Ps,
  getValidationMessage: On,
  increaseTimer: wc,
  isDeprecatedParameter: pr,
  isLoading: gi,
  isTimerRunning: gc,
  isUpdatableParameter: mr,
  isValidParameter: fr,
  isVisible: ll,
  mixin: mc,
  off: kc,
  on: yc,
  once: Ec,
  resumeTimer: _r,
  showLoading: Bt,
  stopTimer: vr,
  toggleTimer: hc
});
class Cc {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const yr = ["swal-title", "swal-html", "swal-footer"], Tc = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return Pc(n), Object.assign(Lc(n), Nc(n), Ac(n), Oc(n), Ic(n), Sc(n), Dc(n, yr));
}, Lc = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    Ot(o, ["name", "value"]);
    const s = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), r = o.getAttribute("value");
    !s || !r || (s in gt && typeof gt[
      /** @type {keyof typeof defaultParams} */
      s
    ] == "boolean" ? t[s] = r !== "false" : s in gt && typeof gt[
      /** @type {keyof typeof defaultParams} */
      s
    ] == "object" ? t[s] = JSON.parse(r) : t[s] = r);
  }), t;
}, Nc = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const s = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), r = o.getAttribute("value");
    !s || !r || (t[s] = new Function(`return ${r}`)());
  }), t;
}, Ac = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    Ot(o, ["type", "color", "aria-label"]);
    const s = o.getAttribute("type");
    if (!s || !["confirm", "cancel", "deny"].includes(s))
      return;
    t[`${s}ButtonText`] = o.innerHTML, t[`show${fo(s)}Button`] = !0;
    const r = o.getAttribute("color");
    r !== null && (t[`${s}ButtonColor`] = r);
    const a = o.getAttribute("aria-label");
    a !== null && (t[`${s}ButtonAriaLabel`] = a);
  }), t;
}, Oc = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  if (n) {
    Ot(n, ["src", "width", "height", "alt"]);
    const o = n.getAttribute("src");
    o !== null && (t.imageUrl = o || void 0);
    const s = n.getAttribute("width");
    s !== null && (t.imageWidth = s || void 0);
    const r = n.getAttribute("height");
    r !== null && (t.imageHeight = r || void 0);
    const a = n.getAttribute("alt");
    a !== null && (t.imageAlt = a || void 0);
  }
  return t;
}, Ic = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (Ot(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, Sc = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (Ot(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((s) => {
    Ot(s, ["value"]);
    const r = s.getAttribute("value");
    if (!r)
      return;
    const a = s.innerHTML;
    t.inputOptions[r] = a;
  })), t;
}, Dc = (e, t) => {
  const n = {};
  for (const o in t) {
    const s = t[o], r = e.querySelector(s);
    r && (Ot(r, []), n[s.replace(/^swal-/, "")] = r.innerHTML.trim());
  }
  return n;
}, Pc = (e) => {
  const t = yr.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Ie(`Unrecognized element <${o}>`);
  });
}, Ot = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Ie([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, Er = 10, $c = (e) => {
  var t, n;
  const o = Se(), s = oe();
  if (!o || !s)
    return;
  typeof e.willOpen == "function" && e.willOpen(s), (t = R.eventEmitter) === null || t === void 0 || t.emit("willOpen", s);
  const a = window.getComputedStyle(document.body).overflowY;
  if (Fc(o, s, e), setTimeout(() => {
    Mc(o, s);
  }, Er), vo() && (Rc(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, a), bl()), vl && e.backdrop === !1 && s.scrollHeight > o.clientHeight && (o.style.pointerEvents = "auto"), !Sn() && !R.previousActiveElement && (R.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const i = e.didOpen;
    setTimeout(() => i(s));
  }
  (n = R.eventEmitter) === null || n === void 0 || n.emit("didOpen", s);
}, kn = (e) => {
  const t = oe();
  if (!t || e.target !== t)
    return;
  const n = Se();
  n && (t.removeEventListener("animationend", kn), t.removeEventListener("transitionend", kn), n.style.overflowY = "auto", je(n, g["no-transition"]));
}, Mc = (e, t) => {
  Us(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", kn), t.addEventListener("transitionend", kn)) : e.style.overflowY = "auto";
}, Rc = (e, t, n) => {
  _l(), t && n !== "hidden" && Ll(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Fc = (e, t, n) => {
  var o;
  (o = n.showClass) !== null && o !== void 0 && o.backdrop && ne(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), xe(t, "grid"), setTimeout(() => {
    var s;
    (s = n.showClass) !== null && s !== void 0 && s.popup && ne(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, Er)) : xe(t, "grid"), ne([document.documentElement, document.body], g.shown), n.heightAuto && n.backdrop && !n.toast && ne([document.documentElement, document.body], g["height-auto"]);
};
var qo = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function Uc(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = qo.email), e.input === "url" && (e.inputValidator = qo.url));
}
function Bc(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Ie('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Vc(e) {
  Uc(e), e.showLoaderOnConfirm && !e.preConfirm && Ie(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), Bc(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), Ai(e);
}
let et;
var un = /* @__PURE__ */ new WeakMap();
class ge {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (ri(
      this,
      un,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    et = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, ai(un, this, this._main(et.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (hr(Object.assign({}, n, t)), R.currentInstance) {
      const r = Ut.swalPromiseResolve.get(R.currentInstance), {
        isAwaitingPromise: a
      } = R.currentInstance;
      R.currentInstance._destroy(), a || r({
        isDismissed: !0
      }), vo() && Js();
    }
    R.currentInstance = et;
    const o = Yc(t, n);
    Vc(o), Object.freeze(o), R.timeout && (R.timeout.stop(), delete R.timeout), clearTimeout(R.restoreFocusTimeout);
    const s = jc(et);
    return Ks(et, o), re.innerParams.set(et, o), Hc(et, s, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  // oxlint-disable-next-line unicorn/no-thenable
  then(t) {
    return Fo(un, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return Fo(un, this).finally(t);
  }
}
const Hc = (e, t, n) => new Promise((o, s) => {
  const r = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  Ut.swalPromiseResolve.set(e, o), Ut.swalPromiseReject.set(e, s), t.confirmButton.onclick = () => {
    jl(e);
  }, t.denyButton.onclick = () => {
    Wl(e);
  }, t.cancelButton.onclick = () => {
    Gl(e, r);
  }, t.closeButton.onclick = () => {
    r(Gt.close);
  }, sc(n, t, r), dl(R, n, r), $l(e, n), $c(n), Wc(R, n, r), Gc(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), Yc = (e, t) => {
  const n = Tc(e), o = Object.assign({}, gt, t, n, e);
  return o.showClass = Object.assign({}, gt.showClass, o.showClass), o.hideClass = Object.assign({}, gt.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, jc = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        oe()
      ),
      container: (
        /** @type {HTMLElement} */
        Se()
      ),
      actions: (
        /** @type {HTMLElement} */
        rn()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        nt()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        Dt()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        jt()
      ),
      loader: (
        /** @type {HTMLElement} */
        Wt()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        go()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        On()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        wo()
      )
    }
  );
  return re.domCache.set(e, t), t;
}, Wc = (e, t, n) => {
  const o = In();
  Ae(o), t.timer && (e.timeout = new Cc(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (xe(o), Re(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && yo(
      /** @type {number} */
      t.timer
    );
  })));
}, Gc = (e, t) => {
  if (!t.toast) {
    if (!An(t.allowEnterKey)) {
      Ds("allowEnterKey", "preConfirm: () => false"), e.popup.focus();
      return;
    }
    Kc(e) || qc(e, t) || Xn(-1, 1);
  }
}, Kc = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && De(n))
      return n.focus(), !0;
  return !1;
}, qc = (e, t) => t.focusDeny && De(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && De(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && De(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1;
ge.prototype.disableButtons = ir;
ge.prototype.enableButtons = ar;
ge.prototype.getInput = or;
ge.prototype.disableInput = cr;
ge.prototype.enableInput = lr;
ge.prototype.hideLoading = yn;
ge.prototype.disableLoading = yn;
ge.prototype.showValidationMessage = ur;
ge.prototype.resetValidationMessage = dr;
ge.prototype.close = wt;
ge.prototype.closePopup = wt;
ge.prototype.closeModal = wt;
ge.prototype.closeToast = wt;
ge.prototype.rejectPromise = Qs;
ge.prototype.update = wr;
ge.prototype._destroy = gr;
Object.assign(ge, xc);
Object.keys(oc).forEach((e) => {
  ge[e] = function(...t) {
    if (et && et[e])
      return et[e](...t);
  };
});
ge.DismissReason = Gt;
ge.version = "11.26.25";
const Jt = ge;
Jt.default = Jt;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:auto}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:auto}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
/*!
  * shared v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function ot(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Xo = {};
function Xc(e) {
  Xo[e] || (Xo[e] = !0, ot(e));
}
const dt = typeof window < "u";
let Me, It;
if (process.env.NODE_ENV !== "production") {
  const e = dt && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Me = (t) => {
    e.mark(t);
  }, It = (t, n, o) => {
    e.measure(t, n, o), e.clearMarks(n), e.clearMarks(o);
  });
}
const zc = /\{([0-9a-zA-Z]+)\}/g;
function Pn(e, ...t) {
  return t.length === 1 && Z(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(zc, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const mt = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Jc = (e, t, n) => Zc({ l: e, k: t, s: n }), Zc = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), ke = (e) => typeof e == "number" && isFinite(e), kr = (e) => Ao(e) === "[object Date]", xn = (e) => Ao(e) === "[object RegExp]", $n = (e) => se(e) && Object.keys(e).length === 0, _e = Object.assign, Qc = Object.create, ae = (e = null) => Qc(e);
let zo;
const Nt = () => zo || (zo = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : ae());
function Jo(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function eu(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const tu = /^\s*javascript\s*(?::|&#0*58;?|&#x0*3a;?|&colon;?)/i, nu = /^(?:href|src|action|formaction)$/i;
function No(e) {
  return tu.test(e);
}
function ou(e) {
  const t = /url\s*\(/gi;
  let n = "", o = 0, s;
  for (; (s = t.exec(e)) !== null; ) {
    const r = s.index, a = t.lastIndex - 1;
    let i = a + 1, l = 1, f = null;
    for (; i < e.length; i++) {
      const m = e[i];
      if (f) {
        m === f && (f = null);
        continue;
      }
      if (m === '"' || m === "'")
        f = m;
      else if (m === "(")
        l++;
      else if (m === ")" && (l--, l === 0))
        break;
    }
    if (l !== 0)
      break;
    const h = e.slice(a + 1, i).trim(), b = h.startsWith('"') && h.endsWith('"') || h.startsWith("'") && h.endsWith("'") ? h.slice(1, -1).trim() : h;
    n += e.slice(o, r), n += No(b) ? "url(about:blank)" : e.slice(r, i + 1), o = i + 1;
  }
  return n + e.slice(o);
}
function Zo(e, t) {
  if (nu.test(e) && No(t))
    return "about:blank";
  const n = e.toLowerCase() === "style" ? ou(t) : t;
  return eu(n);
}
function su(e) {
  return e = e.replace(/([\w:-]+)\s*=\s*"([^"]*)"/g, (n, o, s) => `${o}="${Zo(o, s)}"`), e = e.replace(/([\w:-]+)\s*=\s*'([^']*)'/g, (n, o, s) => `${o}='${Zo(o, s)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && ot("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), e = e.replace(/(\s+(?:href|src|action|formaction)\s*=\s*)([^\s"'=<>`]+)/gi, (n, o, s) => No(s) ? `${o}about:blank` : n), e;
}
const ru = Object.prototype.hasOwnProperty;
function Ye(e, t) {
  return ru.call(e, t);
}
const we = Array.isArray, ue = (e) => typeof e == "function", M = (e) => typeof e == "string", he = (e) => typeof e == "boolean", Z = (e) => e !== null && typeof e == "object", au = (e) => Z(e) && ue(e.then) && ue(e.catch), xr = Object.prototype.toString, Ao = (e) => xr.call(e), se = (e) => Ao(e) === "[object Object]", iu = (e) => e == null ? "" : we(e) || se(e) && e.toString === xr ? JSON.stringify(e, null, 2) : String(e);
function Oo(e, t = "") {
  return e.reduce((n, o, s) => s === 0 ? n + o : n + t + o, "");
}
const Qo = 2;
function lu(e, t = 0, n = e.length) {
  const o = e.split(/\r?\n/);
  let s = 0;
  const r = [];
  for (let a = 0; a < o.length; a++)
    if (s += o[a].length + 1, s >= t) {
      for (let i = a - Qo; i <= a + Qo || n > s; i++) {
        if (i < 0 || i >= o.length)
          continue;
        const l = i + 1;
        r.push(`${l}${" ".repeat(3 - String(l).length)}|  ${o[i]}`);
        const f = o[i].length;
        if (i === a) {
          const h = t - (s - f) + 1, b = Math.max(1, n > s ? f - h : n - t);
          r.push("   |  " + " ".repeat(h) + "^".repeat(b));
        } else if (i > a) {
          if (n > s) {
            const h = Math.max(Math.min(n - s, f), 1);
            r.push("   |  " + "^".repeat(h));
          }
          s += f + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function Cr() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, o) {
      const s = e.get(n);
      s && s.push(o) || e.set(n, [o]);
    },
    off(n, o) {
      const s = e.get(n);
      s && s.splice(s.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (e.get(n) || []).slice().map((s) => s(o)), (e.get("*") || []).slice().map((s) => s(n, o));
    }
  };
}
const dn = (e) => !Z(e) || we(e);
function pn(e, t) {
  if (dn(e) || dn(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: o, des: s } = n.pop();
    Object.keys(o).forEach((r) => {
      r !== "__proto__" && (Z(o[r]) && !Z(s[r]) && (s[r] = Array.isArray(o[r]) ? [] : ae()), dn(s[r]) || dn(o[r]) ? s[r] = o[r] : n.push({ src: o[r], des: s[r] }));
    });
  }
}
/*!
  * message-compiler v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function cu(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Zn(e, t, n) {
  return { start: e, end: t };
}
const W = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, uu = 17, du = {
  // tokenizer error messages
  [W.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [W.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [W.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [W.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [W.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [W.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [W.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [W.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [W.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [W.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [W.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [W.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [W.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [W.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [W.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [W.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Kt(e, t, n = {}) {
  const { domain: o, messages: s, args: r } = n, a = process.env.NODE_ENV !== "production" ? Pn((s || du)[e] || "", ...r || []) : e, i = new SyntaxError(String(a));
  return i.code = e, t && (i.location = t), i.domain = o, i;
}
function fu(e) {
  throw e;
}
const mu = /<\/?[\w\s="/.':;#-\/]+>/, pu = (e) => mu.test(e), Ze = " ", hu = "\r", Le = `
`, wu = "\u2028", gu = "\u2029";
function bu(e) {
  const t = e;
  let n = 0, o = 1, s = 1, r = 0;
  const a = (E) => t[E] === hu && t[E + 1] === Le, i = (E) => t[E] === Le, l = (E) => t[E] === gu, f = (E) => t[E] === wu, h = (E) => a(E) || i(E) || l(E) || f(E), b = () => n, m = () => o, x = () => s, N = () => r, p = (E) => a(E) || l(E) || f(E) ? Le : t[E], k = () => p(n), d = () => p(n + r);
  function v() {
    return r = 0, h(n) && (o++, s = 0), a(n) && n++, n++, s++, t[n];
  }
  function T() {
    return a(n + r) && r++, r++, t[n + r];
  }
  function y() {
    n = 0, o = 1, s = 1, r = 0;
  }
  function A(E = 0) {
    r = E;
  }
  function O() {
    const E = n + r;
    for (; E !== n; )
      v();
    r = 0;
  }
  return {
    index: b,
    line: m,
    column: x,
    peekOffset: N,
    charAt: p,
    currentChar: k,
    currentPeek: d,
    next: v,
    peek: T,
    reset: y,
    resetPeek: A,
    skipToPeek: O
  };
}
const at = void 0, vu = ".", es = "'", _u = "tokenizer";
function yu(e, t = {}) {
  const n = t.location !== !1, o = bu(e), s = () => o.index(), r = () => cu(o.line(), o.column(), o.index()), a = r(), i = s(), l = {
    currentType: 13,
    offset: i,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, f = () => l, { onError: h } = t;
  function b(c, u, C, ...$) {
    const ce = f();
    if (u.column += C, u.offset += C, h) {
      const me = n ? Zn(ce.startLoc, u) : null, ee = Kt(c, me, {
        domain: _u,
        args: $
      });
      h(ee);
    }
  }
  function m(c, u, C) {
    c.endLoc = r(), c.currentType = u;
    const $ = { type: u };
    return n && ($.loc = Zn(c.startLoc, c.endLoc)), C != null && ($.value = C), $;
  }
  const x = (c) => m(
    c,
    13
    /* TokenTypes.EOF */
  );
  function N(c, u) {
    return c.currentChar() === u ? (c.next(), u) : (b(W.EXPECTED_TOKEN, r(), 0, u), "");
  }
  function p(c) {
    let u = "";
    for (; c.currentPeek() === Ze || c.currentPeek() === Le; )
      u += c.currentPeek(), c.peek();
    return u;
  }
  function k(c) {
    const u = p(c);
    return c.skipToPeek(), u;
  }
  function d(c) {
    if (c === at)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u === 95;
  }
  function v(c) {
    if (c === at)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function T(c, u) {
    const { currentType: C } = u;
    if (C !== 2)
      return !1;
    p(c);
    const $ = d(c.currentPeek());
    return c.resetPeek(), $;
  }
  function y(c, u) {
    const { currentType: C } = u;
    if (C !== 2)
      return !1;
    p(c);
    const $ = c.currentPeek() === "-" ? c.peek() : c.currentPeek(), ce = v($);
    return c.resetPeek(), ce;
  }
  function A(c, u) {
    const { currentType: C } = u;
    if (C !== 2)
      return !1;
    p(c);
    const $ = c.currentPeek() === es;
    return c.resetPeek(), $;
  }
  function O(c, u) {
    const { currentType: C } = u;
    if (C !== 7)
      return !1;
    p(c);
    const $ = c.currentPeek() === ".";
    return c.resetPeek(), $;
  }
  function E(c, u) {
    const { currentType: C } = u;
    if (C !== 8)
      return !1;
    p(c);
    const $ = d(c.currentPeek());
    return c.resetPeek(), $;
  }
  function G(c, u) {
    const { currentType: C } = u;
    if (!(C === 7 || C === 11))
      return !1;
    p(c);
    const $ = c.currentPeek() === ":";
    return c.resetPeek(), $;
  }
  function j(c, u) {
    const { currentType: C } = u;
    if (C !== 9)
      return !1;
    const $ = () => {
      const me = c.currentPeek();
      return me === "{" ? d(c.peek()) : me === "@" || me === "|" || me === ":" || me === "." || me === Ze || !me ? !1 : me === Le ? (c.peek(), $()) : K(c, !1);
    }, ce = $();
    return c.resetPeek(), ce;
  }
  function V(c) {
    p(c);
    const u = c.currentPeek() === "|";
    return c.resetPeek(), u;
  }
  function K(c, u = !0) {
    const C = (ce = !1, me = "") => {
      const ee = c.currentPeek();
      return ee === "{" || ee === "@" || !ee ? ce : ee === "|" ? !(me === Ze || me === Le) : ee === Ze ? (c.peek(), C(!0, Ze)) : ee === Le ? (c.peek(), C(!0, Le)) : !0;
    }, $ = C();
    return u && c.resetPeek(), $;
  }
  function U(c, u) {
    const C = c.currentChar();
    return C === at ? at : u(C) ? (c.next(), C) : null;
  }
  function z(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36;
  }
  function I(c) {
    return U(c, z);
  }
  function S(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36 || // $
    u === 45;
  }
  function D(c) {
    return U(c, S);
  }
  function F(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function P(c) {
    return U(c, F);
  }
  function q(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57 || // 0-9
    u >= 65 && u <= 70 || // A-F
    u >= 97 && u <= 102;
  }
  function B(c) {
    return U(c, q);
  }
  function Q(c) {
    let u = "", C = "";
    for (; u = P(c); )
      C += u;
    return C;
  }
  function le(c) {
    let u = "";
    for (; ; ) {
      const C = c.currentChar();
      if (C === "\\") {
        const $ = c.peek();
        $ === "{" || $ === "}" || $ === "@" || $ === "|" || $ === "\\" ? (u += C + $, c.next(), c.next()) : (c.resetPeek(), u += C, c.next());
      } else {
        if (C === "{" || C === "}" || C === "@" || C === "|" || !C)
          break;
        if (C === Ze || C === Le)
          if (K(c))
            u += C, c.next();
          else {
            if (V(c))
              break;
            u += C, c.next();
          }
        else
          u += C, c.next();
      }
    }
    return u;
  }
  function de(c) {
    k(c);
    let u = "", C = "";
    for (; u = D(c); )
      C += u;
    const $ = c.currentChar();
    if ($ && $ !== "}" && $ !== at && $ !== Ze && $ !== Le && $ !== "　") {
      const ce = ve(c);
      return b(W.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, C + ce), C + ce;
    }
    return c.currentChar() === at && b(W.UNTERMINATED_CLOSING_BRACE, r(), 0), C;
  }
  function be(c) {
    k(c);
    let u = "";
    return c.currentChar() === "-" ? (c.next(), u += `-${Q(c)}`) : u += Q(c), c.currentChar() === at && b(W.UNTERMINATED_CLOSING_BRACE, r(), 0), u;
  }
  function Te(c) {
    return c !== es && c !== Le;
  }
  function st(c) {
    k(c), N(c, "'");
    let u = "", C = "";
    for (; u = U(c, Te); )
      u === "\\" ? C += We(c) : C += u;
    const $ = c.currentChar();
    return $ === Le || $ === at ? (b(W.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), $ === Le && (c.next(), N(c, "'")), C) : (N(c, "'"), C);
  }
  function We(c) {
    const u = c.currentChar();
    switch (u) {
      case "\\":
      case "'":
        return c.next(), `\\${u}`;
      case "u":
        return ze(c, u, 4);
      case "U":
        return ze(c, u, 6);
      default:
        return b(W.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, u), "";
    }
  }
  function ze(c, u, C) {
    N(c, u);
    let $ = "";
    for (let ce = 0; ce < C; ce++) {
      const me = B(c);
      if (!me) {
        b(W.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${u}${$}${c.currentChar()}`);
        break;
      }
      $ += me;
    }
    return `\\${u}${$}`;
  }
  function Ge(c) {
    return c !== "{" && c !== "}" && c !== Ze && c !== Le;
  }
  function ve(c) {
    k(c);
    let u = "", C = "";
    for (; u = U(c, Ge); )
      C += u;
    return C;
  }
  function Be(c) {
    let u = "", C = "";
    for (; u = I(c); )
      C += u;
    return C;
  }
  function rt(c) {
    const u = (C) => {
      const $ = c.currentChar();
      return $ === "{" || $ === "@" || $ === "|" || $ === "(" || $ === ")" || !$ || $ === Ze ? C : (C += $, c.next(), u(C));
    };
    return u("");
  }
  function Je(c) {
    k(c);
    const u = N(
      c,
      "|"
      /* TokenChars.Pipe */
    );
    return k(c), u;
  }
  function qt(c, u) {
    let C = null;
    switch (c.currentChar()) {
      case "{":
        return u.braceNest >= 1 && b(W.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), c.next(), C = m(
          u,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), k(c), u.braceNest++, C;
      case "}":
        return u.braceNest > 0 && u.currentType === 2 && b(W.EMPTY_PLACEHOLDER, r(), 0), c.next(), C = m(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), u.braceNest--, u.braceNest > 0 && k(c), u.inLinked && u.braceNest === 0 && (u.inLinked = !1), C;
      case "@":
        return u.braceNest > 0 && b(W.UNTERMINATED_CLOSING_BRACE, r(), 0), C = yt(c, u) || x(u), u.braceNest = 0, C;
      default: {
        let ce = !0, me = !0, ee = !0;
        if (V(c))
          return u.braceNest > 0 && b(W.UNTERMINATED_CLOSING_BRACE, r(), 0), C = m(u, 1, Je(c)), u.braceNest = 0, u.inLinked = !1, C;
        if (u.braceNest > 0 && (u.currentType === 4 || u.currentType === 5 || u.currentType === 6))
          return b(W.UNTERMINATED_CLOSING_BRACE, r(), 0), u.braceNest = 0, Xt(c, u);
        if (ce = T(c, u))
          return C = m(u, 4, de(c)), k(c), C;
        if (me = y(c, u))
          return C = m(u, 5, be(c)), k(c), C;
        if (ee = A(c, u))
          return C = m(u, 6, st(c)), k(c), C;
        if (!ce && !me && !ee)
          return C = m(u, 12, ve(c)), b(W.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, C.value), k(c), C;
        break;
      }
    }
    return C;
  }
  function yt(c, u) {
    const { currentType: C } = u;
    let $ = null;
    const ce = c.currentChar();
    switch ((C === 7 || C === 8 || C === 11 || C === 9) && (ce === Le || ce === Ze) && b(W.INVALID_LINKED_FORMAT, r(), 0), ce) {
      case "@":
        return c.next(), $ = m(
          u,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), u.inLinked = !0, $;
      case ".":
        return k(c), c.next(), m(
          u,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return k(c), c.next(), m(
          u,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return V(c) ? ($ = m(u, 1, Je(c)), u.braceNest = 0, u.inLinked = !1, $) : O(c, u) || G(c, u) ? (k(c), yt(c, u)) : E(c, u) ? (k(c), m(u, 11, Be(c))) : j(c, u) ? (k(c), ce === "{" ? qt(c, u) || $ : m(u, 10, rt(c))) : (C === 7 && b(W.INVALID_LINKED_FORMAT, r(), 0), u.braceNest = 0, u.inLinked = !1, Xt(c, u));
    }
  }
  function Xt(c, u) {
    let C = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (u.braceNest > 0)
      return qt(c, u) || x(u);
    if (u.inLinked)
      return yt(c, u) || x(u);
    switch (c.currentChar()) {
      case "{":
        return qt(c, u) || x(u);
      case "}":
        return b(W.UNBALANCED_CLOSING_BRACE, r(), 0), c.next(), m(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return yt(c, u) || x(u);
      default: {
        if (V(c))
          return C = m(u, 1, Je(c)), u.braceNest = 0, u.inLinked = !1, C;
        if (K(c))
          return m(u, 0, le(c));
        break;
      }
    }
    return C;
  }
  function Un() {
    const { currentType: c, offset: u, startLoc: C, endLoc: $ } = l;
    return l.lastType = c, l.lastOffset = u, l.lastStartLoc = C, l.lastEndLoc = $, l.offset = s(), l.startLoc = r(), o.currentChar() === at ? m(
      l,
      13
      /* TokenTypes.EOF */
    ) : Xt(o, l);
  }
  return {
    nextToken: Un,
    currentOffset: s,
    currentPosition: r,
    context: f
  };
}
const Eu = "parser", ku = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g, xu = /\\([\\@{}|])/g;
function Cu(e, t) {
  return t;
}
function Tu(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function Lu(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function o(d, v, T, y, ...A) {
    const O = d.currentPosition();
    if (O.offset += y, O.column += y, n) {
      const E = t ? Zn(T, O) : null, G = Kt(v, E, {
        domain: Eu,
        args: A
      });
      n(G);
    }
  }
  function s(d, v, T) {
    const y = { type: d };
    return t && (y.start = v, y.end = v, y.loc = { start: T, end: T }), y;
  }
  function r(d, v, T, y) {
    t && (d.end = v, d.loc && (d.loc.end = T));
  }
  function a(d, v) {
    const T = d.context(), y = s(3, T.offset, T.startLoc);
    return y.value = v.replace(xu, Cu), r(y, d.currentOffset(), d.currentPosition()), y;
  }
  function i(d, v) {
    const T = d.context(), { lastOffset: y, lastStartLoc: A } = T, O = s(5, y, A);
    return O.index = parseInt(v, 10), d.nextToken(), r(O, d.currentOffset(), d.currentPosition()), O;
  }
  function l(d, v) {
    const T = d.context(), { lastOffset: y, lastStartLoc: A } = T, O = s(4, y, A);
    return O.key = v, d.nextToken(), r(O, d.currentOffset(), d.currentPosition()), O;
  }
  function f(d, v) {
    const T = d.context(), { lastOffset: y, lastStartLoc: A } = T, O = s(9, y, A);
    return O.value = v.replace(ku, Tu), d.nextToken(), r(O, d.currentOffset(), d.currentPosition()), O;
  }
  function h(d) {
    const v = d.nextToken(), T = d.context(), { lastOffset: y, lastStartLoc: A } = T, O = s(8, y, A);
    return v.type !== 11 ? (o(d, W.UNEXPECTED_EMPTY_LINKED_MODIFIER, T.lastStartLoc, 0), O.value = "", r(O, y, A), {
      nextConsumeToken: v,
      node: O
    }) : (v.value == null && o(d, W.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, Qe(v)), O.value = v.value || "", r(O, d.currentOffset(), d.currentPosition()), {
      node: O
    });
  }
  function b(d, v) {
    const T = d.context(), y = s(7, T.offset, T.startLoc);
    return y.value = v, r(y, d.currentOffset(), d.currentPosition()), y;
  }
  function m(d) {
    const v = d.context(), T = s(6, v.offset, v.startLoc);
    let y = d.nextToken();
    if (y.type === 8) {
      const A = h(d);
      T.modifier = A.node, y = A.nextConsumeToken || d.nextToken();
    }
    switch (y.type !== 9 && o(d, W.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Qe(y)), y = d.nextToken(), y.type === 2 && (y = d.nextToken()), y.type) {
      case 10:
        y.value == null && o(d, W.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Qe(y)), T.key = b(d, y.value || "");
        break;
      case 4:
        y.value == null && o(d, W.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Qe(y)), T.key = l(d, y.value || "");
        break;
      case 5:
        y.value == null && o(d, W.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Qe(y)), T.key = i(d, y.value || "");
        break;
      case 6:
        y.value == null && o(d, W.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Qe(y)), T.key = f(d, y.value || "");
        break;
      default: {
        o(d, W.UNEXPECTED_EMPTY_LINKED_KEY, v.lastStartLoc, 0);
        const A = d.context(), O = s(7, A.offset, A.startLoc);
        return O.value = "", r(O, A.offset, A.startLoc), T.key = O, r(T, A.offset, A.startLoc), {
          nextConsumeToken: y,
          node: T
        };
      }
    }
    return r(T, d.currentOffset(), d.currentPosition()), {
      node: T
    };
  }
  function x(d) {
    const v = d.context(), T = v.currentType === 1 ? d.currentOffset() : v.offset, y = v.currentType === 1 ? v.endLoc : v.startLoc, A = s(2, T, y);
    A.items = [];
    let O = null;
    do {
      const j = O || d.nextToken();
      switch (O = null, j.type) {
        case 0:
          j.value == null && o(d, W.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Qe(j)), A.items.push(a(d, j.value || ""));
          break;
        case 5:
          j.value == null && o(d, W.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Qe(j)), A.items.push(i(d, j.value || ""));
          break;
        case 4:
          j.value == null && o(d, W.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Qe(j)), A.items.push(l(d, j.value || ""));
          break;
        case 6:
          j.value == null && o(d, W.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, Qe(j)), A.items.push(f(d, j.value || ""));
          break;
        case 7: {
          const V = m(d);
          A.items.push(V.node), O = V.nextConsumeToken || null;
          break;
        }
      }
    } while (v.currentType !== 13 && v.currentType !== 1);
    const E = v.currentType === 1 ? v.lastOffset : d.currentOffset(), G = v.currentType === 1 ? v.lastEndLoc : d.currentPosition();
    return r(A, E, G), A;
  }
  function N(d, v, T, y) {
    const A = d.context();
    let O = y.items.length === 0;
    const E = s(1, v, T);
    E.cases = [], E.cases.push(y);
    do {
      const G = x(d);
      O || (O = G.items.length === 0), E.cases.push(G);
    } while (A.currentType !== 13);
    return O && o(d, W.MUST_HAVE_MESSAGES_IN_PLURAL, T, 0), r(E, d.currentOffset(), d.currentPosition()), E;
  }
  function p(d) {
    const v = d.context(), { offset: T, startLoc: y } = v, A = x(d);
    return v.currentType === 13 ? A : N(d, T, y, A);
  }
  function k(d) {
    const v = yu(d, _e({}, e)), T = v.context(), y = s(0, T.offset, T.startLoc);
    return t && y.loc && (y.loc.source = d), y.body = p(v), e.onCacheKey && (y.cacheKey = e.onCacheKey(d)), T.currentType !== 13 && o(v, W.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, d[T.offset] || ""), r(y, v.currentOffset(), v.currentPosition()), y;
  }
  return { parse: k };
}
function Qe(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Nu(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (r) => (n.helpers.add(r), r) };
}
function ts(e, t) {
  for (let n = 0; n < e.length; n++)
    Io(e[n], t);
}
function Io(e, t) {
  switch (e.type) {
    case 1:
      ts(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      ts(e.items, t);
      break;
    case 6: {
      Io(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Au(e, t = {}) {
  const n = Nu(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Io(e.body, n);
  const o = n.context();
  e.helpers = Array.from(o.helpers);
}
function Ou(e) {
  const t = e.body;
  return t.type === 2 ? ns(t) : t.cases.forEach((n) => ns(n)), e;
}
function ns(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const o = e.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = Oo(t);
      for (let n = 0; n < e.items.length; n++) {
        const o = e.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const Iu = "minifier";
function $t(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      $t(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let o = 0; o < n.length; o++)
        $t(n[o]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let o = 0; o < n.length; o++)
        $t(n[o]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      $t(t.key), t.k = t.key, delete t.key, t.modifier && ($t(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw Kt(W.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Iu,
          args: [e.type]
        });
  }
  delete e.type;
}
const Su = "parser";
function Du(e, t) {
  const { filename: n, breakLineCode: o, needIndent: s } = t, r = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: s,
    indentLevel: 0
  };
  r && e.loc && (a.source = e.loc.source);
  const i = () => a;
  function l(p, k) {
    a.code += p;
  }
  function f(p, k = !0) {
    const d = k ? o : "";
    l(s ? d + "  ".repeat(p) : d);
  }
  function h(p = !0) {
    const k = ++a.indentLevel;
    p && f(k);
  }
  function b(p = !0) {
    const k = --a.indentLevel;
    p && f(k);
  }
  function m() {
    f(a.indentLevel);
  }
  return {
    context: i,
    push: l,
    indent: h,
    deindent: b,
    newline: m,
    helper: (p) => `_${p}`,
    needIndent: () => a.needIndent
  };
}
function Pu(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Vt(e, t.key), t.modifier ? (e.push(", "), Vt(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function $u(e, t) {
  const { helper: n, needIndent: o } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const s = t.items.length;
  for (let r = 0; r < s && (Vt(e, t.items[r]), r !== s - 1); r++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function Mu(e, t) {
  const { helper: n, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const s = t.cases.length;
    for (let r = 0; r < s && (Vt(e, t.cases[r]), r !== s - 1); r++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function Ru(e, t) {
  t.body ? Vt(e, t.body) : e.push("null");
}
function Vt(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Ru(e, t);
      break;
    case 1:
      Mu(e, t);
      break;
    case 2:
      $u(e, t);
      break;
    case 6:
      Pu(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw Kt(W.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Su,
          args: [t.type]
        });
  }
}
const Fu = (e, t = {}) => {
  const n = M(t.mode) ? t.mode : "normal", o = M(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const s = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, r = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], i = Du(e, {
    filename: o,
    breakLineCode: s,
    needIndent: r
  });
  i.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(r), a.length > 0 && (i.push(`const { ${Oo(a.map((h) => `${h}: _${h}`), ", ")} } = ctx`), i.newline()), i.push("return "), Vt(i, e), i.deindent(r), i.push("}"), delete e.helpers;
  const { code: l, map: f } = i.context();
  return {
    ast: e,
    code: l,
    map: f ? f.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Uu(e, t = {}) {
  const n = _e({}, t), o = !!n.jit, s = !!n.minify, r = n.optimize == null ? !0 : n.optimize, i = Lu(n).parse(e);
  return o ? (r && Ou(i), s && $t(i), { ast: i, code: "" }) : (Au(i, n), Fu(i, n));
}
/*!
  * core-base v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function Bu() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Nt().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Nt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function Xe(e) {
  return Z(e) && So(e) === 0 && (Ye(e, "b") || Ye(e, "body"));
}
const Tr = ["b", "body"];
function Vu(e) {
  return vt(e, Tr);
}
const Lr = ["c", "cases"];
function Hu(e) {
  return vt(e, Lr, []);
}
const Nr = ["s", "static"];
function Yu(e) {
  return vt(e, Nr);
}
const Ar = ["i", "items"];
function ju(e) {
  return vt(e, Ar, []);
}
const Or = ["t", "type"];
function So(e) {
  return vt(e, Or);
}
const Ir = ["v", "value"];
function fn(e, t) {
  const n = vt(e, Ir);
  if (n != null)
    return n;
  throw Zt(t);
}
const Sr = ["m", "modifier"];
function Wu(e) {
  return vt(e, Sr);
}
const Dr = ["k", "key"];
function Gu(e) {
  const t = vt(e, Dr);
  if (t)
    return t;
  throw Zt(
    6
    /* NodeTypes.Linked */
  );
}
function vt(e, t, n) {
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    if (Ye(e, s) && e[s] != null)
      return e[s];
  }
  return n;
}
const Pr = [
  ...Tr,
  ...Lr,
  ...Nr,
  ...Ar,
  ...Dr,
  ...Sr,
  ...Ir,
  ...Or
];
function Zt(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Yn(e) {
  return (n) => Ku(n, e);
}
function Ku(e, t) {
  const n = Vu(t);
  if (n == null)
    throw Zt(
      0
      /* NodeTypes.Resource */
    );
  if (So(n) === 1) {
    const r = Hu(n);
    return e.plural(r.reduce((a, i) => [
      ...a,
      os(e, i)
    ], []));
  } else
    return os(e, n);
}
function os(e, t) {
  const n = Yu(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const o = ju(t).reduce((s, r) => [...s, Qn(e, r)], []);
    return e.normalize(o);
  }
}
function Qn(e, t) {
  const n = So(t);
  switch (n) {
    case 3:
      return fn(t, n);
    case 9:
      return fn(t, n);
    case 4: {
      const o = t;
      if (Ye(o, "k") && o.k)
        return e.interpolate(e.named(o.k));
      if (Ye(o, "key") && o.key)
        return e.interpolate(e.named(o.key));
      throw Zt(n);
    }
    case 5: {
      const o = t;
      if (Ye(o, "i") && ke(o.i))
        return e.interpolate(e.list(o.i));
      if (Ye(o, "index") && ke(o.index))
        return e.interpolate(e.list(o.index));
      throw Zt(n);
    }
    case 6: {
      const o = t, s = Wu(o), r = Gu(o);
      return e.linked(Qn(e, r), s ? Qn(e, s) : void 0, e.type);
    }
    case 7:
      return fn(t, n);
    case 8:
      return fn(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const qu = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Xu(e, t) {
  t && pu(e) && ot(Pn(qu, { source: e }));
}
const zu = (e) => e;
let mn = ae();
function Ju(e, t = {}) {
  let n = !1;
  const o = t.onError || fu;
  return t.onError = (s) => {
    n = !0, o(s);
  }, { ...Uu(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Zu(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && M(e)) {
    const n = he(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Xu(e, n);
    const s = (t.onCacheKey || zu)(e), r = mn[s];
    if (r)
      return r;
    const { ast: a, detectError: i } = Ju(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = Yn(a);
    return i ? l : mn[s] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !Xe(e))
      return ot(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const o = mn[n];
      return o || (mn[n] = Yn(e));
    } else
      return Yn(e);
  }
}
let Qt = null;
function Qu(e) {
  Qt = e;
}
function ed(e, t, n) {
  Qt && Qt.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const td = /* @__PURE__ */ nd("function:translate");
function nd(e) {
  return (t) => Qt && Qt.emit(e, t);
}
const Ne = {
  INVALID_ARGUMENT: uu,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, od = 24;
function lt(e) {
  return Kt(e, null, process.env.NODE_ENV !== "production" ? { messages: sd } : void 0);
}
const sd = {
  [Ne.INVALID_ARGUMENT]: "Invalid arguments",
  [Ne.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Ne.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Ne.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Ne.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Ne.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Ne.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Do(e, t) {
  return t.locale != null ? ss(t.locale) : ss(e.locale);
}
let jn;
function ss(e) {
  if (M(e))
    return e;
  if (ue(e)) {
    if (e.resolvedOnce && jn != null)
      return jn;
    if (e.constructor.name === "Function") {
      const t = e();
      if (au(t))
        throw lt(Ne.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return jn = t;
    } else
      throw lt(Ne.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw lt(Ne.NOT_SUPPORT_LOCALE_TYPE);
}
function rd(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...we(t) ? t : Z(t) ? Object.keys(t) : M(t) ? [t] : [n]
  ])];
}
function eo(e, t, n) {
  const o = M(n) ? n : Cn, s = e;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let r = s.__localeChainCache.get(o);
  if (!r) {
    r = [];
    let a = [n];
    for (; we(a); )
      a = rs(r, a, t);
    const i = we(t) || !se(t) ? t : t.default ? t.default : null;
    a = M(i) ? [i] : i, we(a) && rs(r, a, !1), s.__localeChainCache.set(o, r);
  }
  return r;
}
function rs(e, t, n) {
  let o = !0;
  for (let s = 0; s < t.length && he(o); s++) {
    const r = t[s];
    M(r) && (o = ad(e, t[s], n));
  }
  return o;
}
function ad(e, t, n) {
  let o;
  const s = t.split("-");
  do {
    const r = s.join("-");
    o = id(e, r, n), s.splice(-1, 1);
  } while (s.length && o === !0);
  return o;
}
function id(e, t, n) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    e.push(s), (we(n) || se(n)) && n[s] && (o = n[s]);
  }
  return o;
}
const _t = [];
_t[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
_t[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
_t[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
_t[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
_t[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
_t[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
_t[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const ld = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function cd(e) {
  return ld.test(e);
}
function ud(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function dd(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function fd(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : cd(t) ? ud(t) : "*" + t;
}
function md(e) {
  const t = [];
  let n = -1, o = 0, s = 0, r, a, i, l, f, h, b;
  const m = [];
  m[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = i : a += i;
  }, m[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, m[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    m[
      0
      /* Actions.APPEND */
    ](), s++;
  }, m[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, o = 4, m[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, a === void 0 || (a = fd(a), a === !1))
        return !1;
      m[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function x() {
    const N = e[n + 1];
    if (o === 5 && N === "'" || o === 6 && N === '"')
      return n++, i = "\\" + N, m[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, r = e[n], !(r === "\\" && x())) {
      if (l = dd(r), b = _t[o], f = b[l] || b.l || 8, f === 8 || (o = f[0], f[1] !== void 0 && (h = m[f[1]], h && (i = r, h() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const as = /* @__PURE__ */ new Map();
function pd(e, t) {
  return Z(e) ? e[t] : null;
}
function hd(e, t) {
  if (!Z(e))
    return null;
  let n = as.get(t);
  if (n || (n = md(t), n && as.set(t, n)), !n)
    return null;
  const o = n.length;
  let s = e, r = 0;
  for (; r < o; ) {
    const a = n[r];
    if (Pr.includes(a) && Xe(s) || !Z(s) || !Ye(s, a))
      return null;
    const i = s[a];
    if (i === void 0 || ue(s))
      return null;
    s = i, r++;
  }
  return s;
}
const Ee = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  INVALID_NUMBER_ARGUMENT: 8,
  INVALID_DATE_ARGUMENT: 9
}, Pt = 10, wd = {
  [Ee.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Ee.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Ee.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Ee.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Ee.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Ee.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Ee.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.",
  [Ee.INVALID_NUMBER_ARGUMENT]: "Invalid argument for number formatting: expected a number but received '{value}'.",
  [Ee.INVALID_DATE_ARGUMENT]: "Invalid argument for datetime formatting: expected a Date, number, or ISO string but received '{value}'."
};
function ut(e, ...t) {
  return Pn(wd[e], ...t);
}
const gd = "11.4.4", Mn = -1, Cn = "en-US", Ht = "", is = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function bd() {
  return {
    upper: (e, t) => t === "text" && M(e) ? e.toUpperCase() : t === "vnode" && Z(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && M(e) ? e.toLowerCase() : t === "vnode" && Z(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && M(e) ? is(e) : t === "vnode" && Z(e) && "__v_isVNode" in e ? is(e.children) : e
  };
}
let $r;
function vd(e) {
  $r = e;
}
let Mr;
function _d(e) {
  Mr = e;
}
let Rr;
function yd(e) {
  Rr = e;
}
let Fr = null;
const Ed = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Fr = e;
}, kd = /* @__NO_SIDE_EFFECTS__ */ () => Fr;
let Ur = null;
const ls = (e) => {
  Ur = e;
}, xd = () => Ur;
let cs = 0;
function Cd(e = {}) {
  const t = ue(e.onWarn) ? e.onWarn : ot, n = M(e.version) ? e.version : gd, o = M(e.locale) || ue(e.locale) ? e.locale : Cn, s = ue(o) ? Cn : o, r = we(e.fallbackLocale) || se(e.fallbackLocale) || M(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s, a = se(e.messages) ? e.messages : Wn(s), i = se(e.datetimeFormats) ? e.datetimeFormats : Wn(s), l = se(e.numberFormats) ? e.numberFormats : Wn(s), f = _e(ae(), e.modifiers, bd()), h = e.pluralRules || ae(), b = ue(e.missing) ? e.missing : null, m = he(e.missingWarn) || xn(e.missingWarn) ? e.missingWarn : !0, x = he(e.fallbackWarn) || xn(e.fallbackWarn) ? e.fallbackWarn : !0, N = !!e.fallbackFormat, p = !!e.unresolving, k = ue(e.postTranslation) ? e.postTranslation : null, d = se(e.processor) ? e.processor : null, v = he(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, T = !!e.escapeParameter, y = ue(e.messageCompiler) ? e.messageCompiler : $r;
  process.env.NODE_ENV !== "production" && ue(e.messageCompiler) && Xc(ut(Ee.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const A = ue(e.messageResolver) ? e.messageResolver : Mr || pd, O = ue(e.localeFallbacker) ? e.localeFallbacker : Rr || rd, E = Z(e.fallbackContext) ? e.fallbackContext : void 0, G = e, j = Z(G.__datetimeFormatters) ? G.__datetimeFormatters : /* @__PURE__ */ new Map(), V = Z(G.__numberFormatters) ? G.__numberFormatters : /* @__PURE__ */ new Map(), K = Z(G.__meta) ? G.__meta : {};
  cs++;
  const U = {
    version: n,
    cid: cs,
    locale: o,
    fallbackLocale: r,
    messages: a,
    modifiers: f,
    pluralRules: h,
    missing: b,
    missingWarn: m,
    fallbackWarn: x,
    fallbackFormat: N,
    unresolving: p,
    postTranslation: k,
    processor: d,
    warnHtmlMessage: v,
    escapeParameter: T,
    messageCompiler: y,
    messageResolver: A,
    localeFallbacker: O,
    fallbackContext: E,
    onWarn: t,
    __meta: K
  };
  return U.datetimeFormats = i, U.numberFormats = l, U.__datetimeFormatters = j, U.__numberFormatters = V, process.env.NODE_ENV !== "production" && (U.__v_emitter = G.__v_emitter != null ? G.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && ed(U, n, K), U;
}
const Wn = (e) => ({ [e]: ae() });
function Rn(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Br(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Po(e, t, n, o, s) {
  const { missing: r, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: s,
      groupId: `${s}:${t}`
    });
  }
  if (r !== null) {
    const i = r(e, n, t, s);
    return M(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && Br(o, t) && a(ut(Ee.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function zt(e, t, n) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Vr(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Td(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let o = n + 1; o < t.length; o++)
    if (Vr(e, t[o]))
      return !0;
  return !1;
}
const us = typeof Intl < "u", Hr = {
  dateTimeFormat: us && typeof Intl.DateTimeFormat < "u",
  numberFormat: us && typeof Intl.NumberFormat < "u"
};
function ds(e, ...t) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: s, onWarn: r, localeFallbacker: a } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !Hr.dateTimeFormat)
    return r(ut(Ee.CANNOT_FORMAT_DATE)), Ht;
  if (!M(t[0]) && !kr(t[0]) && !ke(t[0]))
    return process.env.NODE_ENV !== "production" && r(ut(Ee.INVALID_DATE_ARGUMENT, {
      value: String(t[0])
    })), Ht;
  const [l, f, h, b] = to(...t), m = he(h.missingWarn) ? h.missingWarn : e.missingWarn, x = he(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, N = !!h.part, p = Do(e, h), k = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    p
  );
  if (!M(l) || l === "")
    return new Intl.DateTimeFormat(p.replace(/!/g, ""), b).format(f);
  let d = {}, v, T = null, y = p, A = null;
  const O = "datetime format";
  for (let j = 0; j < k.length; j++) {
    if (v = A = k[j], process.env.NODE_ENV !== "production" && p !== v && Rn(x, l) && r(ut(Ee.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: v
    })), process.env.NODE_ENV !== "production" && p !== v) {
      const V = e.__v_emitter;
      V && V.emit("fallback", {
        type: O,
        key: l,
        from: y,
        to: A,
        groupId: `${O}:${l}`
      });
    }
    if (d = n[v] || {}, T = d[l], se(T))
      break;
    Po(e, l, v, m, O), y = A;
  }
  if (!se(T) || !M(v))
    return o ? Mn : l;
  let E = `${v}__${l}`;
  $n(b) || (E = `${E}__${JSON.stringify(b)}`);
  let G = i.get(E);
  return G || (G = new Intl.DateTimeFormat(v, _e({}, T, b)), i.set(E, G)), N ? G.formatToParts(f) : G.format(f);
}
const Yr = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function to(...e) {
  const [t, n, o, s] = e, r = ae();
  let a = ae(), i;
  if (M(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw lt(Ne.INVALID_ISO_DATE_ARGUMENT);
    const f = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    i = new Date(f);
    try {
      i.toISOString();
    } catch {
      throw lt(Ne.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (kr(t)) {
    if (isNaN(t.getTime()))
      throw lt(Ne.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (ke(t))
    i = t;
  else
    throw lt(Ne.INVALID_ARGUMENT);
  return M(n) ? r.key = n : se(n) && Object.keys(n).forEach((l) => {
    Yr.includes(l) ? a[l] = n[l] : r[l] = n[l];
  }), M(o) ? r.locale = o : se(o) && (a = o), se(s) && (a = s), [r.key || "", i, r, a];
}
function fs(e, t, n) {
  const o = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    o.__datetimeFormatters.has(r) && o.__datetimeFormatters.delete(r);
  }
}
function ms(e, ...t) {
  const { numberFormats: n, unresolving: o, fallbackLocale: s, onWarn: r, localeFallbacker: a } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !Hr.numberFormat)
    return r(ut(Ee.CANNOT_FORMAT_NUMBER)), Ht;
  if (!ke(t[0]))
    return process.env.NODE_ENV !== "production" && r(ut(Ee.INVALID_NUMBER_ARGUMENT, {
      value: String(t[0])
    })), Ht;
  const [l, f, h, b] = no(...t), m = he(h.missingWarn) ? h.missingWarn : e.missingWarn, x = he(h.fallbackWarn) ? h.fallbackWarn : e.fallbackWarn, N = !!h.part, p = Do(e, h), k = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    p
  );
  if (!M(l) || l === "")
    return new Intl.NumberFormat(p.replace(/!/g, ""), b).format(f);
  let d = {}, v, T = null, y = p, A = null;
  const O = "number format";
  for (let j = 0; j < k.length; j++) {
    if (v = A = k[j], process.env.NODE_ENV !== "production" && p !== v && Rn(x, l) && r(ut(Ee.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: v
    })), process.env.NODE_ENV !== "production" && p !== v) {
      const V = e.__v_emitter;
      V && V.emit("fallback", {
        type: O,
        key: l,
        from: y,
        to: A,
        groupId: `${O}:${l}`
      });
    }
    if (d = n[v] || {}, T = d[l], se(T))
      break;
    Po(e, l, v, m, O), y = A;
  }
  if (!se(T) || !M(v))
    return o ? Mn : l;
  let E = `${v}__${l}`;
  $n(b) || (E = `${E}__${JSON.stringify(b)}`);
  let G = i.get(E);
  return G || (G = new Intl.NumberFormat(v, _e({}, T, b)), i.set(E, G)), N ? G.formatToParts(f) : G.format(f);
}
const jr = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function no(...e) {
  const [t, n, o, s] = e, r = ae();
  let a = ae();
  if (!ke(t))
    throw lt(Ne.INVALID_ARGUMENT);
  const i = t;
  return M(n) ? r.key = n : se(n) && Object.keys(n).forEach((l) => {
    jr.includes(l) ? a[l] = n[l] : r[l] = n[l];
  }), M(o) ? r.locale = o : se(o) && (a = o), se(s) && (a = s), [r.key || "", i, r, a];
}
function ps(e, t, n) {
  const o = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    o.__numberFormatters.has(r) && o.__numberFormatters.delete(r);
  }
}
const Ld = (e) => e, Nd = (e) => "", Ad = "text", Od = (e) => e.length === 0 ? "" : Oo(e), Id = iu;
function Gn(e, t) {
  return e = Math.abs(e), t === 2 ? e === 1 ? 0 : 1 : Math.min(e, 2);
}
function Sd(e) {
  var n, o;
  const t = ke(e.pluralIndex) ? e.pluralIndex : -1;
  return ke((n = e.named) == null ? void 0 : n.count) ? e.named.count : ke((o = e.named) == null ? void 0 : o.n) ? e.named.n : t;
}
function Dd(e = {}) {
  var d, v, T, y;
  const t = e.locale, n = Sd(e), o = M(t) && ue((d = e.pluralRules) == null ? void 0 : d[t]) ? e.pluralRules[t] : Gn, s = o === Gn ? void 0 : Gn, r = (A) => A[o(n, A.length, s)], a = e.list || [], i = (A) => a[A], l = e.named || ae();
  ke(e.pluralIndex) && (l.count || (l.count = e.pluralIndex), l.n || (l.n = e.pluralIndex));
  const f = (A) => l[A];
  function h(A, O) {
    const E = ue(e.messages) ? e.messages(A, !!O) : Z(e.messages) ? e.messages[A] : !1;
    return E || (e.parent ? e.parent.message(A) : Nd);
  }
  const b = (A) => e.modifiers ? e.modifiers[A] : Ld, m = ue((v = e.processor) == null ? void 0 : v.normalize) ? e.processor.normalize : Od, x = ue((T = e.processor) == null ? void 0 : T.interpolate) ? e.processor.interpolate : Id, N = M((y = e.processor) == null ? void 0 : y.type) ? e.processor.type : Ad, k = {
    list: i,
    named: f,
    plural: r,
    linked: (A, ...O) => {
      const [E, G] = O;
      let j = "text", V = "";
      O.length === 1 ? Z(E) ? (V = E.modifier || V, j = E.type || j) : M(E) && (V = E || V) : O.length === 2 && (M(E) && (V = E || V), M(G) && (j = G || j));
      const K = h(A, !0)(k), U = K === "" || K === void 0 ? A : K, z = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        j === "vnode" && we(U) && V ? U[0] : U
      );
      return V ? b(V)(z, j) : z;
    },
    message: h,
    type: N,
    interpolate: x,
    normalize: m,
    values: _e(ae(), a, l)
  };
  return k;
}
const hs = () => "", He = (e) => ue(e);
function ws(e, ...t) {
  const { fallbackFormat: n, postTranslation: o, unresolving: s, messageCompiler: r, fallbackLocale: a, messages: i } = e, [l, f] = oo(...t), h = he(f.missingWarn) ? f.missingWarn : e.missingWarn, b = he(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn, m = he(f.escapeParameter) ? f.escapeParameter : e.escapeParameter, x = !!f.resolvedMessage, N = M(f.default) || he(f.default) ? he(f.default) ? r ? l : () => l : f.default : n ? r ? l : () => l : null, p = n || N != null && (M(N) || ue(N)), k = Do(e, f);
  m && Pd(f);
  let [d, v, T] = x ? [
    l,
    k,
    i[k] || ae()
  ] : Wr(e, l, k, a, b, h), y = d, A = l;
  if (!x && !(M(y) || Xe(y) || He(y)) && p && (y = N, A = y), !x && (!(M(y) || Xe(y) || He(y)) || !M(v)))
    return s ? Mn : l;
  if (process.env.NODE_ENV !== "production" && M(y) && e.messageCompiler == null)
    return ot(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let O = !1;
  const E = () => {
    O = !0;
  }, G = He(y) ? y : Gr(e, l, v, y, A, E);
  if (O)
    return y;
  const j = Fd(e, v, T, f), V = Dd(j), K = $d(e, G, V);
  let U = o ? o(K, l) : K;
  if (m && M(U) && (U = su(U)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const z = {
      timestamp: Date.now(),
      key: M(l) ? l : He(y) ? y.key : "",
      locale: v || (He(y) ? y.locale : ""),
      format: M(y) ? y : He(y) ? y.source : "",
      message: U
    };
    z.meta = _e({}, e.__meta, /* @__PURE__ */ kd() || {}), td(z);
  }
  return U;
}
function Pd(e) {
  we(e.list) ? e.list = e.list.map((t) => M(t) ? Jo(t) : t) : Z(e.named) && Object.keys(e.named).forEach((t) => {
    M(e.named[t]) && (e.named[t] = Jo(e.named[t]));
  });
}
function Wr(e, t, n, o, s, r) {
  const { messages: a, onWarn: i, messageResolver: l, localeFallbacker: f } = e, h = f(e, o, n);
  let b = ae(), m, x = null, N = n, p = null;
  const k = "translate";
  for (let d = 0; d < h.length; d++) {
    m = p = h[d], process.env.NODE_ENV !== "production" && n !== m && !Vr(n, m) && Rn(s, t) && i(ut(Ee.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: m
    }));
    const v = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
    process.env.NODE_ENV !== "production" && n !== m && v && v.emit("fallback", {
      type: k,
      key: t,
      from: N,
      to: p,
      groupId: `${k}:${t}`
    }), b = a[m] || ae();
    let T = null, y, A;
    if (process.env.NODE_ENV !== "production" && dt && v && (T = window.performance.now(), y = "intlify-message-resolve-start", A = "intlify-message-resolve-end", Me && Me(y)), (x = l(b, t)) === null && (x = b[t]), process.env.NODE_ENV !== "production" && dt && v) {
      const O = window.performance.now();
      v && T && x && v.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: x,
        time: O - T,
        groupId: `${k}:${t}`
      }), y && A && Me && It && (Me(A), It("intlify message resolve", y, A));
    }
    if (M(x) || Xe(x) || He(x))
      break;
    if (!Td(m, h)) {
      const O = Po(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        m,
        r,
        k
      );
      O !== t && (x = O);
    }
    N = p;
  }
  return [x, m, b];
}
function Gr(e, t, n, o, s, r) {
  const { messageCompiler: a, warnHtmlMessage: i } = e;
  if (He(o)) {
    const x = o;
    return x.locale = x.locale || n, x.key = x.key || t, x;
  }
  if (a == null) {
    const x = () => o;
    return x.locale = n, x.key = t, x;
  }
  const l = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let f = null, h, b;
  process.env.NODE_ENV !== "production" && dt && l && (f = window.performance.now(), h = "intlify-message-compilation-start", b = "intlify-message-compilation-end", Me && Me(h));
  const m = a(o, Md(e, n, s, o, i, r));
  if (process.env.NODE_ENV !== "production" && dt && l) {
    const x = window.performance.now();
    l && f && l.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: x - f,
      groupId: `translate:${t}`
    }), h && b && Me && It && (Me(b), It("intlify message compilation", h, b));
  }
  return m.locale = n, m.key = t, m.source = o, m;
}
function $d(e, t, n) {
  const o = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let s = null, r, a;
  process.env.NODE_ENV !== "production" && dt && o && (s = window.performance.now(), r = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", Me && Me(r));
  const i = t(n);
  if (process.env.NODE_ENV !== "production" && dt && o) {
    const l = window.performance.now();
    o && s && o.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: l - s,
      groupId: `translate:${t.key}`
    }), r && a && Me && It && (Me(a), It("intlify message evaluation", r, a));
  }
  return i;
}
function oo(...e) {
  const [t, n, o] = e, s = ae();
  if (!M(t) && !ke(t) && !He(t) && !Xe(t))
    throw lt(Ne.INVALID_ARGUMENT);
  const r = ke(t) ? String(t) : (He(t), t);
  return ke(n) ? s.plural = n : M(n) ? s.default = n : se(n) && !$n(n) ? s.named = n : we(n) && (s.list = n), ke(o) ? s.plural = o : M(o) ? s.default = o : se(o) && _e(s, o), [r, s];
}
function Md(e, t, n, o, s, r) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: s,
    onError: (a) => {
      if (r && r(a), process.env.NODE_ENV !== "production") {
        const i = Rd(o), l = a.location && i && lu(i, a.location.start.offset, a.location.end.offset), f = e.__v_emitter;
        f && i && f.emit("compile-error", {
          message: i,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        });
        const h = `Message compilation error: ${a.message}`;
        throw new SyntaxError(l ? `${h}
${l}` : h);
      }
      throw a;
    },
    onCacheKey: (a) => Jc(t, n, a)
  };
}
function Rd(e) {
  if (M(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function Fd(e, t, n, o) {
  const { modifiers: s, pluralRules: r, messageResolver: a, fallbackLocale: i, fallbackWarn: l, missingWarn: f, fallbackContext: h } = e, m = {
    locale: t,
    modifiers: s,
    pluralRules: r,
    messages: (x, N) => {
      let p = a(n, x);
      if (p == null && (h || N)) {
        const [k, , d] = Wr(
          h || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          x,
          t,
          i,
          l,
          f
        );
        p = k ?? a(d, x);
      }
      if (M(p) || Xe(p)) {
        let k = !1;
        const v = Gr(e, x, t, p, x, () => {
          k = !0;
        });
        return k ? hs : v;
      } else return He(p) ? p : hs;
    }
  };
  return e.processor && (m.processor = e.processor), o.list && (m.list = o.list), o.named && (m.named = o.named), ke(o.plural) && (m.pluralIndex = o.plural), m;
}
Bu();
/*!
  * vue-i18n v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
const Ud = "11.4.4";
function Bd() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Nt().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Nt().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Nt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Nt().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const ye = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: od,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function Ft(e, ...t) {
  return Kt(e, null, process.env.NODE_ENV !== "production" ? { messages: Vd, args: t } : void 0);
}
const Vd = {
  [ye.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [ye.INVALID_ARGUMENT]: "Invalid argument",
  [ye.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [ye.NOT_INSTALLED]: "Need to install with `app.use` function",
  [ye.UNEXPECTED_ERROR]: "Unexpected error",
  [ye.REQUIRED_VALUE]: "Required in value: {0}",
  [ye.INVALID_VALUE]: "Invalid value",
  [ye.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [ye.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [ye.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [ye.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, so = /* @__PURE__ */ mt("__translateVNode"), ro = /* @__PURE__ */ mt("__datetimeParts"), ao = /* @__PURE__ */ mt("__numberParts"), en = /* @__PURE__ */ mt("__enableEmitter"), tn = /* @__PURE__ */ mt("__disableEmitter"), Hd = mt("__setPluralRules"), Kr = /* @__PURE__ */ mt("__injectWithOption"), Mt = /* @__PURE__ */ mt("__dispose"), tt = {
  FALLBACK_TO_ROOT: Pt,
  // 10
  NOT_FOUND_PARENT_SCOPE: Pt + 1,
  IGNORE_OBJ_FLATTEN: Pt + 2,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: Pt + 3,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: Pt + 4,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: Pt + 5
}, Yd = {
  [tt.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [tt.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [tt.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [tt.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [tt.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [tt.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function Tn(e, ...t) {
  return Pn(Yd[e], ...t);
}
function nn(e) {
  if (!Z(e) || Xe(e))
    return e;
  for (const t in e)
    if (Ye(e, t))
      if (!t.includes("."))
        Z(e[t]) && nn(e[t]);
      else {
        const n = t.split("."), o = n.length - 1;
        let s = e, r = !1;
        for (let a = 0; a < o; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in s || (s[n[a]] = ae()), !Z(s[n[a]])) {
            process.env.NODE_ENV !== "production" && ot(Tn(tt.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), r = !0;
            break;
          }
          s = s[n[a]];
        }
        if (r || (Xe(s) ? Pr.includes(n[o]) || delete e[t] : (s[n[o]] = e[t], delete e[t])), !Xe(s)) {
          const a = s[n[o]];
          Z(a) && nn(a);
        }
      }
  return e;
}
function qr(e, t) {
  const { messages: n, __i18n: o, messageResolver: s, flatJson: r } = t, a = se(n) ? n : we(o) ? ae() : { [e]: ae() };
  if (we(o) && o.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: l, resource: f } = i;
      l ? (a[l] = a[l] || ae(), pn(f, a[l])) : pn(f, a);
    } else
      M(i) && pn(JSON.parse(i), a);
  }), s == null && r)
    for (const i in a)
      Ye(a, i) && nn(a[i]);
  return a;
}
function Xr(e) {
  return e.type;
}
function jd(e, t, n) {
  let o = Z(t.messages) ? t.messages : ae();
  "__i18nGlobal" in n && (o = qr(e.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const s = Object.keys(o);
  s.length && s.forEach((r) => {
    e.mergeLocaleMessage(r, o[r]);
  });
  {
    if (Z(t.datetimeFormats)) {
      const r = Object.keys(t.datetimeFormats);
      r.length && r.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (Z(t.numberFormats)) {
      const r = Object.keys(t.numberFormats);
      r.length && r.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function gs(e) {
  return Tt(sa, null, e, 0);
}
function $o() {
  const e = "currentInstance";
  return e in Bn ? Bn[e] : Bn.getCurrentInstance();
}
const bs = "__INTLIFY_META__", vs = () => [], Wd = () => !1;
let _s = 0;
function ys(e) {
  return (t, n, o, s) => e(n, o, $o() || void 0, s);
}
const Gd = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = $o();
  let t = null;
  return e && (t = Xr(e)[bs]) ? { [bs]: t } : null;
};
function Es(e = {}) {
  const { __root: t, __injectWithOption: n } = e, o = t === void 0, s = e.flatJson, r = dt ? J : oa;
  let a = he(e.inheritLocale) ? e.inheritLocale : !0;
  const i = r(
    // prettier-ignore
    t && a ? t.locale.value : M(e.locale) ? e.locale : Cn
  ), l = r(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : M(e.fallbackLocale) || we(e.fallbackLocale) || se(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), f = r(qr(i.value, e)), h = r(se(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), b = r(se(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let m = t ? t.missingWarn : he(e.missingWarn) || xn(e.missingWarn) ? e.missingWarn : !0, x = t ? t.fallbackWarn : he(e.fallbackWarn) || xn(e.fallbackWarn) ? e.fallbackWarn : !0, N = t ? t.fallbackRoot : he(e.fallbackRoot) ? e.fallbackRoot : !0, p = !!e.fallbackFormat, k = ue(e.missing) ? e.missing : null, d = ue(e.missing) ? ys(e.missing) : null, v = ue(e.postTranslation) ? e.postTranslation : null, T = t ? t.warnHtmlMessage : he(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, y = !!e.escapeParameter;
  const A = t ? t.modifiers : se(e.modifiers) ? e.modifiers : {};
  let O = e.pluralRules || t && t.pluralRules, E;
  E = (() => {
    o && ls(null);
    const _ = {
      version: Ud,
      locale: i.value,
      fallbackLocale: l.value,
      messages: f.value,
      modifiers: A,
      pluralRules: O,
      missing: d === null ? void 0 : d,
      missingWarn: m,
      fallbackWarn: x,
      fallbackFormat: p,
      unresolving: !0,
      postTranslation: v === null ? void 0 : v,
      warnHtmlMessage: T,
      escapeParameter: y,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    _.datetimeFormats = h.value, _.numberFormats = b.value, _.__datetimeFormatters = se(E) ? E.__datetimeFormatters : void 0, _.__numberFormatters = se(E) ? E.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (_.__v_emitter = se(E) ? E.__v_emitter : void 0);
    const L = Cd(_);
    return o && ls(L), L;
  })(), zt(E, i.value, l.value);
  function j() {
    return [
      i.value,
      l.value,
      f.value,
      h.value,
      b.value
    ];
  }
  const V = Oe({
    get: () => i.value,
    set: (_) => {
      E.locale = _, i.value = _;
    }
  }), K = Oe({
    get: () => l.value,
    set: (_) => {
      E.fallbackLocale = _, l.value = _, zt(E, i.value, _);
    }
  }), U = Oe(() => f.value), z = /* @__PURE__ */ Oe(() => h.value), I = /* @__PURE__ */ Oe(() => b.value);
  function S() {
    return ue(v) ? v : null;
  }
  function D(_) {
    v = _, E.postTranslation = _;
  }
  function F() {
    return k;
  }
  function P(_) {
    _ !== null && (d = ys(_)), k = _, E.missing = d;
  }
  function q(_, L) {
    return _ !== "translate" || !L.resolvedMessage;
  }
  const B = (_, L, te, fe, Et, kt) => {
    j();
    let Ve;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (E.fallbackContext = t ? xd() : void 0), Ve = _(E);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (E.fallbackContext = void 0);
    }
    if (te !== "translate exists" && // for not `te` (e.g `t`)
    ke(Ve) && Ve === Mn || te === "translate exists" && !Ve) {
      const [xt, Zr] = L();
      if (process.env.NODE_ENV !== "production" && t && M(xt) && q(te, Zr) && (N && (Rn(x, xt) || Br(m, xt)) && ot(Tn(tt.FALLBACK_TO_ROOT, {
        key: xt,
        type: te
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Ro } = E;
        Ro && N && Ro.emit("fallback", {
          type: te,
          key: xt,
          to: "global",
          groupId: `${te}:${xt}`
        });
      }
      return t && N ? fe(t) : Et(xt);
    } else {
      if (kt(Ve))
        return Ve;
      throw Ft(ye.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Q(..._) {
    return B((L) => Reflect.apply(ws, null, [L, ..._]), () => oo(..._), "translate", (L) => Reflect.apply(L.t, L, [..._]), (L) => L, (L) => M(L));
  }
  function le(..._) {
    const [L, te, fe] = _;
    if (fe && !Z(fe))
      throw Ft(ye.INVALID_ARGUMENT);
    return Q(L, te, _e({ resolvedMessage: !0 }, fe || {}));
  }
  function de(..._) {
    return B((L) => Reflect.apply(ds, null, [L, ..._]), () => to(..._), "datetime format", (L) => Reflect.apply(L.d, L, [..._]), () => Ht, (L) => M(L) || we(L));
  }
  function be(..._) {
    return B((L) => Reflect.apply(ms, null, [L, ..._]), () => no(..._), "number format", (L) => Reflect.apply(L.n, L, [..._]), () => Ht, (L) => M(L) || we(L));
  }
  function Te(_) {
    return _.map((L) => M(L) || ke(L) || he(L) ? gs(String(L)) : L);
  }
  const We = {
    normalize: Te,
    interpolate: (_) => _,
    type: "vnode"
  };
  function ze(..._) {
    return B((L) => {
      let te;
      const fe = L;
      try {
        fe.processor = We, te = Reflect.apply(ws, null, [fe, ..._]);
      } finally {
        fe.processor = null;
      }
      return te;
    }, () => oo(..._), "translate", (L) => L[so](..._), (L) => [gs(L)], (L) => we(L));
  }
  function Ge(..._) {
    return B((L) => Reflect.apply(ms, null, [L, ..._]), () => no(..._), "number format", (L) => L[ao](..._), vs, (L) => M(L) || we(L));
  }
  function ve(..._) {
    return B((L) => Reflect.apply(ds, null, [L, ..._]), () => to(..._), "datetime format", (L) => L[ro](..._), vs, (L) => M(L) || we(L));
  }
  function Be(_) {
    O = _, E.pluralRules = O;
  }
  function rt(_, L) {
    return B(() => {
      if (!_)
        return !1;
      const te = M(L) ? L : i.value, fe = M(L) ? [te] : eo(E, l.value, te);
      for (let Et = 0; Et < fe.length; Et++) {
        const kt = yt(fe[Et]);
        let Ve = E.messageResolver(kt, _);
        if (Ve === null && (Ve = kt[_]), Xe(Ve) || He(Ve) || M(Ve))
          return !0;
      }
      return !1;
    }, () => [_], "translate exists", (te) => Reflect.apply(te.te, te, [_, L]), Wd, (te) => he(te));
  }
  function Je(_) {
    let L = null;
    const te = eo(E, l.value, i.value);
    for (let fe = 0; fe < te.length; fe++) {
      const Et = f.value[te[fe]] || {}, kt = E.messageResolver(Et, _);
      if (kt != null) {
        L = kt;
        break;
      }
    }
    return L;
  }
  function qt(_) {
    const L = Je(_);
    return L ?? (t ? t.tm(_) || {} : {});
  }
  function yt(_) {
    return f.value[_] || {};
  }
  function Xt(_, L) {
    if (s) {
      const te = { [_]: L };
      for (const fe in te)
        Ye(te, fe) && nn(te[fe]);
      L = te[_];
    }
    f.value[_] = L, E.messages = f.value;
  }
  function Un(_, L) {
    f.value[_] = f.value[_] || {};
    const te = { [_]: L };
    if (s)
      for (const fe in te)
        Ye(te, fe) && nn(te[fe]);
    L = te[_], pn(L, f.value[_]), E.messages = f.value;
  }
  function c(_) {
    return h.value[_] || {};
  }
  function u(_, L) {
    h.value[_] = L, E.datetimeFormats = h.value, fs(E, _, L);
  }
  function C(_, L) {
    h.value[_] = _e(h.value[_] || {}, L), E.datetimeFormats = h.value, fs(E, _, L);
  }
  function $(_) {
    return b.value[_] || {};
  }
  function ce(_, L) {
    b.value[_] = L, E.numberFormats = b.value, ps(E, _, L);
  }
  function me(_, L) {
    b.value[_] = _e(b.value[_] || {}, L), E.numberFormats = b.value, ps(E, _, L);
  }
  _s++, t && dt && (bt(t.locale, (_) => {
    a && (i.value = _, E.locale = _, zt(E, i.value, l.value));
  }), bt(t.fallbackLocale, (_) => {
    a && (l.value = _, E.fallbackLocale = _, zt(E, i.value, l.value));
  }));
  const ee = {
    id: _s,
    locale: V,
    fallbackLocale: K,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(_) {
      a = _, _ && t && (i.value = t.locale.value, l.value = t.fallbackLocale.value, zt(E, i.value, l.value));
    },
    get availableLocales() {
      return Object.keys(f.value).sort();
    },
    messages: U,
    get modifiers() {
      return A;
    },
    get pluralRules() {
      return O || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return m;
    },
    set missingWarn(_) {
      m = _, E.missingWarn = m;
    },
    get fallbackWarn() {
      return x;
    },
    set fallbackWarn(_) {
      x = _, E.fallbackWarn = x;
    },
    get fallbackRoot() {
      return N;
    },
    set fallbackRoot(_) {
      N = _;
    },
    get fallbackFormat() {
      return p;
    },
    set fallbackFormat(_) {
      p = _, E.fallbackFormat = p;
    },
    get warnHtmlMessage() {
      return T;
    },
    set warnHtmlMessage(_) {
      T = _, E.warnHtmlMessage = _;
    },
    get escapeParameter() {
      return y;
    },
    set escapeParameter(_) {
      y = _, E.escapeParameter = _;
    },
    t: Q,
    getLocaleMessage: yt,
    setLocaleMessage: Xt,
    mergeLocaleMessage: Un,
    getPostTranslationHandler: S,
    setPostTranslationHandler: D,
    getMissingHandler: F,
    setMissingHandler: P,
    [Hd]: Be
  };
  return ee.datetimeFormats = z, ee.numberFormats = I, ee.rt = le, ee.te = rt, ee.tm = qt, ee.d = de, ee.n = be, ee.getDateTimeFormat = c, ee.setDateTimeFormat = u, ee.mergeDateTimeFormat = C, ee.getNumberFormat = $, ee.setNumberFormat = ce, ee.mergeNumberFormat = me, ee[Kr] = n, ee[so] = ze, ee[ro] = ve, ee[ao] = Ge, process.env.NODE_ENV !== "production" && (ee[en] = (_) => {
    E.__v_emitter = _;
  }, ee[tn] = () => {
    E.__v_emitter = void 0;
  }), ee;
}
function Ln(e, t) {
}
const Mo = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Kd({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, s) => [
    ...o,
    // prettier-ignore
    ...s.type === Ce ? s.children : [s]
  ], []) : t.reduce((n, o) => {
    const s = e[o];
    return s && (n[o] = s()), n;
  }, ae());
}
function zr() {
  return Ce;
}
_e({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => ke(e) || !isNaN(e)
  }
}, Mo);
function qd(e) {
  return we(e) && !M(e[0]);
}
function Jr(e, t, n, o) {
  const { slots: s, attrs: r } = t;
  return () => {
    const a = () => {
      const f = { part: !0 };
      let h = ae();
      e.locale && (f.locale = e.locale), M(e.format) ? f.key = e.format : Z(e.format) && (M(e.format.key) && (f.key = e.format.key), h = Object.keys(e.format).reduce((x, N) => n.includes(N) ? _e(ae(), x, { [N]: e.format[N] }) : x, ae()));
      const b = o(e.value, f, h);
      let m = [f.key];
      return we(b) ? m = b.map((x, N) => {
        const p = s[x.type], k = p ? p({ [x.type]: x.value, index: N, parts: b }) : [x.value];
        return qd(k) && (k[0].key = `${x.type}-${N}`), k;
      }) : M(b) && (m = [b]), m;
    }, i = _e(ae(), r), l = M(e.tag) || Z(e.tag) ? e.tag : zr();
    return Z(l) ? hn(l, i, { default: a }) : hn(l, i, a());
  };
}
_e({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Mo);
const Xd = /* @__PURE__ */ mt("global-vue-i18n");
function Fn(e = {}) {
  const t = $o();
  if (t == null)
    throw Ft(ye.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Ft(ye.NOT_INSTALLED);
  const n = zd(t), o = Zd(n), s = Xr(t), r = Jd(e, s);
  if (r === "global")
    return jd(o, e, s), o;
  if (r === "parent") {
    let l = ks(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && ot(Tn(tt.NOT_FOUND_PARENT_SCOPE)), l = o), l;
  }
  if (r === "isolated") {
    if (n.mode !== "composition")
      throw Ft(ye.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const l = n, f = _e({}, e), h = ks(n, t);
    f.__root = h || o;
    const b = Es(f);
    l.__composerExtend && (b[Mt] = l.__composerExtend(b));
    let m = null;
    if (process.env.NODE_ENV !== "production") {
      m = Cr();
      const N = b;
      N[en] && N[en](m), m.on("*", Ln);
    }
    return Qr() && ea(() => {
      if (process.env.NODE_ENV !== "production") {
        m && m.off("*", Ln);
        const p = b;
        p[tn] && p[tn]();
      }
      const N = b[Mt];
      N && (N(), delete b[Mt]);
    }), b;
  }
  const a = n;
  let i = a.__getInstance(t);
  if (i == null) {
    const l = _e({}, e);
    "__i18n" in s && (l.__i18n = s.__i18n), o && (l.__root = o), i = Es(l), a.__composerExtend && (i[Mt] = a.__composerExtend(i)), ef(a, t, i), a.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && r === "local" && ot(Tn(tt.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function zd(e) {
  const t = ta(e.isCE ? Xd : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw Ft(e.isCE ? ye.NOT_INSTALLED_WITH_PROVIDE : ye.UNEXPECTED_ERROR);
  return t;
}
function Jd(e, t) {
  return $n(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Zd(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function ks(e, t, n = !1) {
  let o = null;
  const s = t.root;
  let r = Qd(t, n);
  for (; r != null; ) {
    const a = e;
    if (e.mode === "composition")
      o = a.__getInstance(r);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = a.__getInstance(r);
      i != null && (o = i.__composer, n && o && !o[Kr] && (o = null));
    }
    if (o != null || s === r)
      break;
    r = r.parent;
  }
  return o;
}
function Qd(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function ef(e, t, n) {
  let o = null;
  Nn(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, o = Cr();
      const s = n;
      s[en] && s[en](o), o.on("*", Ln);
    }
  }, t), na(() => {
    const s = n;
    process.env.NODE_ENV !== "production" && (o && o.off("*", Ln), s[tn] && s[tn](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const r = s[Mt];
    r && (r(), delete s[Mt]);
  }, t);
}
_e({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Mo);
Bd();
vd(Zu);
_d(hd);
yd(eo);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Nt();
  e.__INTLIFY__ = !0, Qu(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function tf(e, t) {
  const n = J({}), o = J({
    tz: "",
    merchant_name: "",
    memo1: "",
    memo2: ""
  }), s = J(!1), r = J(null);
  return { matrix: n, loading: s, error: r, merchantInfo: o, fetchMatrix: async (f = 1, h = 10) => {
    s.value = !0;
    try {
      n.value = await e.getSevenDayMatrix(f, h);
    } catch (b) {
      r.value = b.message || "無法獲取預約矩陣";
    } finally {
      s.value = !1;
    }
  }, submitBooking: async (f) => {
    s.value = !0;
    try {
      return await e.createOrder(f);
    } catch (h) {
      throw r.value = h.message || "預約失敗", h;
    } finally {
      s.value = !1;
    }
  }, fetchMerchantInfo: async (f) => {
    s.value = !0;
    try {
      o.value = await t.getMerchantInfo(f);
    } catch (h) {
      r.value = h.message || "無法獲取預約矩陣";
    } finally {
      s.value = !1;
    }
  } };
}
const nf = { class: "flex flex-col h-screen max-w-xl mx-auto bg-slate-100 font-sans text-slate-700 overflow-hidden" }, of = { class: "flex-1 p-8 space-y-10 overflow-y-auto custom-scrollbar" }, sf = { class: "space-y-3 py-4 text-left" }, rf = { class: "text-3xl font-black tracking-tighter border-l-4 border-slate-700 pl-4 leading-none" }, af = ["innerHTML"], lf = { class: "space-y-4" }, cf = { class: "relative isolate" }, uf = ["value"], df = {
  key: 0,
  class: "space-y-4"
}, ff = { class: "flex gap-3 overflow-x-auto pb-4 no-scrollbar px-1" }, mf = ["onClick"], pf = { class: "text-[10px] font-black uppercase opacity-60" }, hf = { class: "text-xl font-black mt-1" }, wf = {
  key: 1,
  class: "mb-8"
}, gf = {
  key: 0,
  class: "p-8 text-center animate-pulse font-bold uppercase tracking-widest text-xs"
}, bf = {
  key: 1,
  class: "grid grid-cols-4 gap-2"
}, vf = ["onClick", "disabled"], _f = {
  key: 0,
  class: "absolute bottom-1.5 w-3 h-[2px] bg-white/40 rounded-full"
}, yf = {
  key: 2,
  class: "mt-4 text-center p-4 bg-slate-200/50 rounded-xl text-slate-500 text-[10px] font-bold uppercase tracking-wider"
}, Ef = { class: "space-y-4 pb-12" }, kf = { class: "space-y-3" }, xf = ["onUpdate:modelValue", "type", "placeholder"], Cf = { class: "p-8 bg-slate-100 border-t border-slate-200" }, Tf = { class: "mb-3 text-center" }, Lf = {
  key: 0,
  class: "text-[10px] font-black uppercase tracking-widest text-slate-400"
}, Nf = ["disabled"], Af = /* @__PURE__ */ ft({
  __name: "ReservationPage",
  props: {
    bookingApi: {},
    tzApi: {},
    merchantID: {}
  },
  setup(e) {
    it.extend(oi), it.locale("zh-tw");
    const { t } = Fn(), n = e, { matrix: o, merchantInfo: s, loading: r, error: a, fetchMatrix: i, submitBooking: l, fetchMerchantInfo: f } = tf(n.bookingApi, n.tzApi), h = J(2), b = J(""), m = J(""), x = J({
      name: "",
      phone: "",
      email: ""
    }), N = ["name", "phone", "email"], p = Oe(() => {
      var I;
      const U = o.value;
      if ((I = U == null ? void 0 : U["0"]) != null && I["0"]) return U[0][0];
      const z = [];
      for (let S = 10; S <= 20; S++)
        z.push(`${S.toString().padStart(2, "0")}:00`), S < 20 && z.push(`${S.toString().padStart(2, "0")}:30`);
      return z;
    }), k = Oe(() => o.value ? Object.fromEntries(Object.entries(o.value).filter(([U]) => U !== "0")) : {}), d = Oe(() => Object.keys(k.value).sort()), v = Oe(() => !b.value || !k.value[b.value] ? [] : k.value[b.value][h.value] || []), T = (U) => v.value.includes(U), y = (U, z) => it(U).format(z);
    bt(k, (U) => {
      const z = Object.keys(U).sort();
      z.length > 0 && !b.value && (b.value = z[0]);
    }, { deep: !0 }), bt([h, b], () => {
      m.value = "";
    }), Nn(async () => {
      f(n.merchantID), await i();
    });
    const A = (U) => /^\S+@\S+\.\S+$/.test(U), O = (U) => /^09\d{8}$/.test(U), E = Oe(() => b.value ? m.value ? x.value.name.trim() === "" ? "INVALID_NAME" : O(x.value.phone) ? A(x.value.email) ? "SUCCESS" : "INVALID_EMAIL" : "INVALID_PHONE" : "MISSING_TIME" : "MISSING_DATE"), G = Oe(() => E.value === "SUCCESS"), j = Oe(() => ({
      SUCCESS: "Confirm Order / 確認預約",
      MISSING_DATE: "Please Select Date / 請選擇日期",
      MISSING_TIME: "Please Select Time / 請選擇時段",
      INVALID_NAME: "Name Required / 請輸入姓名",
      INVALID_PHONE: "Invalid Phone / 電話格式錯誤",
      INVALID_EMAIL: "Invalid Email / 信箱格式錯誤"
    })[E.value]), V = async () => {
      if (!G.value) return;
      const U = it(`${b.value} ${m.value}`).utc(!0).toISOString();
      try {
        await l({
          guest_count: h.value,
          merchant_name: s.value.merchant_name,
          start_time: U,
          name: x.value.name,
          phone: x.value.phone,
          email: x.value.email
        }), await Jt.fire({
          title: '<span class="font-black text-slate-700 uppercase tracking-tighter">確認信已寄出</span>',
          html: `
        <div class="text-slate-600 font-bold leading-relaxed px-4 text-sm">
          確認連結已發送至<br/>
          <span class="bg-slate-700 text-white px-3 py-1 rounded-full mt-2 inline-block">${x.value.email}</span><br/>
          <p class="mt-4 opacity-60 uppercase tracking-widest text-[10px]">確認連結將在15分鐘後過期</p>
        </div>`,
          icon: "success",
          iconColor: "#334155",
          background: "#f1f5f9",
          confirmButtonText: t("common.ok"),
          confirmButtonColor: "#334155",
          customClass: {
            popup: "rounded-[2.5rem] border-none shadow-2xl",
            confirmButton: "rounded-xl font-black px-10 py-3 tracking-widest"
          }
        }), await i();
      } catch (z) {
        Kn.error("預約失敗", z), await Jt.fire({ title: "ERROR", text: "預約失敗，請稍後再試", icon: "error", confirmButtonColor: "#334155" });
      }
    }, K = ["1de956ad-ea63-4e74-853a-8b24b4ef3d26", "8cba5a9b-8007-4a4c-830e-01d402f1ccc0"];
    return bt(() => n.merchantID, (U) => {
      U && K.includes(U) && (x.value = { name: "測試人員", phone: "0912345678", email: "bjk543@gmail.com" });
    }, { immediate: !0 }), (U, z) => (H(), Y("div", nf, [
      w("main", of, [
        w("header", sf, [
          w("h1", rf, X(ie(s).merchant_name), 1),
          w("span", {
            class: "text-xs font-bold tracking-widest",
            innerHTML: ie(s).memo2
          }, null, 8, af)
        ]),
        w("section", lf, [
          z[1] || (z[1] = w("label", { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50" }, "01. Guests / 預約人數", -1)),
          w("div", cf, [
            qe(w("select", {
              "onUpdate:modelValue": z[0] || (z[0] = (I) => h.value = I),
              class: "w-full appearance-none bg-white text-slate-700 p-5 rounded-2xl font-bold transition-all outline-none border-2 border-transparent focus:border-slate-700 shadow-sm cursor-pointer hover:bg-slate-50"
            }, [
              (H(), Y(Ce, null, Ke(8, (I) => w("option", {
                key: I,
                value: I
              }, X(I) + " 人 / " + X(I) + " " + X(I > 1 ? "Guests" : "Guest"), 9, uf)), 64))
            ], 512), [
              [xs, h.value]
            ])
          ])
        ]),
        d.value.length ? (H(), Y("section", df, [
          z[2] || (z[2] = w("label", { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50" }, "02. Date / 預約日期", -1)),
          w("div", ff, [
            (H(!0), Y(Ce, null, Ke(d.value, (I) => (H(), Y("button", {
              key: I,
              onClick: (S) => b.value = I,
              class: Pe([
                "min-w-[80px] py-5 rounded-2xl transition-all border-2 flex flex-col items-center shrink-0",
                b.value === I ? "bg-slate-700 text-white border-slate-700 shadow-lg" : "bg-white text-slate-700 border-transparent hover:border-slate-300 shadow-sm"
              ])
            }, [
              w("span", pf, X(y(I, "ddd")), 1),
              w("span", hf, X(y(I, "DD")), 1)
            ], 10, mf))), 128))
          ])
        ])) : $e("", !0),
        d.value.length ? (H(), Y("section", wf, [
          z[3] || (z[3] = w("label", { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50 mb-3 ml-1" }, "03. Time / 預約時段", -1)),
          ie(r) ? (H(), Y("div", gf, " Synchronizing... ")) : (H(), Y("div", bf, [
            (H(!0), Y(Ce, null, Ke(p.value, (I) => (H(), Y("button", {
              key: I,
              onClick: (S) => m.value = I,
              disabled: !T(I),
              class: Pe([
                /* 使用 px-0 釋放所有橫向空間，py-4 維持垂直厚度展現專業感 */
                /* text-[12px] 或 text-xs 是四欄布局的最佳平衡點 */
                "py-4 px-0 rounded-xl font-mono font-bold transition-all border-2 text-[12px] shadow-sm text-center relative flex items-center justify-center",
                m.value === I ? "bg-slate-700 text-white border-slate-700 shadow-md z-10 scale-[1.02]" : T(I) ? "bg-white text-slate-700 border-transparent hover:border-slate-300" : "bg-slate-50 text-slate-300 border-transparent cursor-not-allowed opacity-40"
              ])
            }, [
              Lt(X(I) + " ", 1),
              m.value === I ? (H(), Y("div", _f)) : $e("", !0)
            ], 10, vf))), 128))
          ])),
          !ie(r) && v.value.length === 0 ? (H(), Y("div", yf, " ⚠️ No slots available for this date. ")) : $e("", !0)
        ])) : $e("", !0),
        w("section", Ef, [
          z[4] || (z[4] = w("label", { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50" }, "04. Info / 聯繫資訊", -1)),
          w("div", kf, [
            (H(), Y(Ce, null, Ke(N, (I) => w("div", { key: I }, [
              qe(w("input", {
                "onUpdate:modelValue": (S) => x.value[I] = S,
                type: I === "email" ? "email" : "text",
                placeholder: I.toUpperCase(),
                class: "w-full p-5 bg-white rounded-xl border-2 border-transparent outline-none focus:border-slate-700 transition-all font-bold placeholder:text-slate-300 shadow-sm"
              }, null, 8, xf), [
                [ra, x.value[I]]
              ])
            ])), 64))
          ])
        ])
      ]),
      w("footer", Cf, [
        w("div", Tf, [
          Tt(io, { name: "fade" }, {
            default: lo(() => [
              !G.value && (b.value || m.value) ? (H(), Y("p", Lf, " Status: " + X(j.value), 1)) : $e("", !0)
            ]),
            _: 1
          })
        ]),
        w("button", {
          onClick: V,
          disabled: !G.value || ie(r),
          class: Pe([
            "w-full py-5 rounded-2xl font-black text-lg tracking-[0.3em] uppercase transition-all active:scale-[0.98]",
            G.value ? "bg-slate-700 text-white shadow-lg shadow-slate-300" : "bg-slate-200 text-slate-400 cursor-not-allowed"
          ])
        }, [
          ie(r) ? (H(), Y(Ce, { key: 0 }, [
            Lt("Processing...")
          ], 64)) : (H(), Y(Ce, { key: 1 }, [
            Lt(X(G.value ? "Confirm Order" : j.value), 1)
          ], 64))
        ], 10, Nf)
      ])
    ]));
  }
}), pm = /* @__PURE__ */ co(Af, [["__scopeId", "data-v-b5e9f736"]]);
function Of(e) {
  const t = J({}), n = J(!1), o = J(null);
  return { reservations: t, loading: n, error: o, loadData: async () => {
    n.value = !0, o.value = null;
    try {
      const r = await e.fetchReservations();
      t.value = r || {}, Kn.log("載入預約資料成功:", t.value);
    } catch (r) {
      o.value = "無法載入預約資料", Kn.error("載入預約資料失敗:", r);
    } finally {
      n.value = !1;
    }
  } };
}
const If = { class: "p-4 md:p-8 bg-slate-50 font-sans antialiased text-slate-700" }, Sf = { class: "max-w-5xl mx-auto" }, Df = { class: "mb-8 flex flex-col md:flex-row md:items-center justify-between gap-6" }, Pf = { class: "flex flex-col gap-1" }, $f = { class: "text-slate-500 font-bold uppercase text-xs tracking-widest mt-1" }, Mf = { class: "text-indigo-700 font-black" }, Rf = { class: "flex flex-wrap items-center gap-2 mb-8" }, Ff = ["onClick"], Uf = {
  key: 0,
  class: "mr-1"
}, Bf = ["disabled"], Vf = {
  key: 0,
  class: "mb-10"
}, Hf = { class: "flex items-center gap-3 overflow-x-auto pb-4 no-scrollbar scroll-smooth" }, Yf = ["onClick"], jf = { class: "text-[10px] uppercase opacity-60 tracking-[0.2em] mb-1" }, Wf = { class: "text-xl leading-none tabular-nums" }, Gf = { class: "relative min-h-[700px]" }, Kf = { class: "flex items-center justify-between mb-4 px-2" }, qf = { class: "text-xs font-black text-slate-700 uppercase tracking-[0.3em]" }, Xf = { class: "flex flex-col md:flex-row md:items-center gap-6" }, zf = {
  key: 0,
  class: "flex -space-x-4"
}, Jf = { class: "text-2xl font-black leading-none" }, Zf = { class: "flex-1" }, Qf = { class: "flex-1 px-4 md:px-0" }, em = { class: "flex items-center gap-3" }, tm = { class: "font-black text-slate-700 text-2xl tracking-tight leading-none" }, nm = { class: "flex items-center gap-1 bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-[10px] font-black uppercase" }, om = { class: "flex flex-wrap items-center gap-x-6 gap-y-2 mt-3 text-sm text-slate-500 font-bold" }, sm = { class: "flex items-center gap-2" }, rm = {
  key: 0,
  class: "text-slate-700 hidden md:inline"
}, am = {
  key: 1,
  class: "text-slate-700 font-medium"
}, im = { class: "flex flex-row md:flex-col items-center md:items-end gap-4 px-4 md:px-0 md:pl-8 border-t md:border-t-0 md:border-l border-slate-100 pt-4 md:pt-0" }, lm = {
  key: 1,
  class: "text-center py-40 bg-white rounded-[3rem] border-4 border-dashed border-slate-100"
}, cm = { class: "text-2xl font-black text-slate-700 uppercase tracking-[0.2em]" }, um = /* @__PURE__ */ ft({
  __name: "AdminReservationList",
  props: {
    api: {}
  },
  setup(e) {
    const t = e, { reservations: n, loading: o, error: s, loadData: r } = Of(t.api);
    Nn(async () => {
      await r();
    });
    const a = J(null), i = J(2);
    J(null);
    const l = Oe(() => {
      const p = n.value;
      return p ? i.value === null ? Object.keys(p) : Object.keys(p).filter((k) => p[k].some((d) => d.status === i.value)) : [];
    });
    bt(l, (p) => {
      if (p.length > 0 && !a.value) {
        const k = it().format("YYYY-MM-DD");
        a.value = p.includes(k) ? k : p[0];
      }
    }, { immediate: !0 });
    const f = [
      { label: "已確認", value: 2, color: "green" },
      { label: "全部", value: null, color: "slate" }
    ], h = Oe(() => {
      const p = n.value;
      if (!a.value || !p) return [];
      let k = p[a.value] || [];
      return i.value !== null && (k = k.filter((d) => d.status === i.value)), k;
    }), b = Oe(() => {
      const p = n.value;
      return p ? Object.values(p).reduce((k, d) => k + ((d == null ? void 0 : d.length) || 0), 0) : 0;
    }), m = (p) => {
      if (!p) return "slate";
      const k = it(p).hour();
      return k >= 5 && k < 12 ? "cyan" : k >= 12 && k < 17 ? "amber" : "indigo";
    }, x = (p) => {
      switch (p) {
        case 1:
          return "bg-orange-100 text-orange-700 border-orange-200";
        case 2:
          return "bg-green-100 text-green-700 border-green-200";
        case 3:
          return "bg-red-100 text-red-700 border-red-200";
      }
    }, N = (p) => p ? it(p).format("HH:mm") : "--:--";
    return (p, k) => (H(), Y("div", If, [
      w("div", Sf, [
        w("header", Df, [
          w("div", Pf, [
            k[3] || (k[3] = w("h1", { class: "text-4xl font-black tracking-tight text-slate-700" }, "預約看板", -1)),
            w("p", $f, [
              k[1] || (k[1] = Lt(" 目前共有 ", -1)),
              w("span", Mf, X(b.value), 1),
              k[2] || (k[2] = Lt(" 筆預約 ", -1))
            ])
          ]),
          w("div", Rf, [
            (H(), Y(Ce, null, Ke(f, (d) => w("button", {
              key: d.label,
              onClick: (v) => i.value = d.value,
              class: Pe([[
                i.value === d.value ? `bg-${d.color}-700 text-white shadow-lg` : `bg-white text-slate-700 hover:bg-${d.color}-100`
              ], "px-5 py-2 rounded-full border text-xs font-black uppercase tracking-wider transition-all active:scale-95"])
            }, [
              i.value === d.value ? (H(), Y("span", Uf, "●")) : $e("", !0),
              Lt(" " + X(d.label), 1)
            ], 10, Ff)), 64))
          ]),
          w("button", {
            onClick: k[0] || (k[0] = //@ts-ignore
            (...d) => ie(r) && ie(r)(...d)),
            disabled: ie(o),
            class: "flex items-center gap-2 px-6 py-3 bg-white border border-slate-200 rounded-2xl font-bold shadow-sm hover:shadow-md transition-all active:scale-95 disabled:opacity-50"
          }, [
            w("span", {
              class: Pe({ "animate-spin": ie(o) })
            }, X(ie(o) ? "⌛" : "🔄"), 3),
            Lt(" " + X(ie(o) ? "載入中..." : "重新整理"), 1)
          ], 8, Bf)
        ]),
        l.value.length > 0 ? (H(), Y("div", Vf, [
          w("nav", Hf, [
            (H(!0), Y(Ce, null, Ke(l.value, (d) => (H(), Y("button", {
              key: d,
              onClick: (v) => a.value = d,
              class: Pe([[
                a.value === d ? "bg-indigo-700 text-white shadow-xl shadow-indigo-100 scale-105 border-indigo-700" : "bg-white text-slate-500 hover:bg-slate-100 border-slate-200"
              ], "flex-shrink-0 px-6 py-4 rounded-[2rem] border-2 font-black transition-all duration-700 flex flex-col items-center min-w-[110px]"])
            }, [
              w("span", jf, X(ie(it)(d).format("ddd")), 1),
              w("span", Wf, X(ie(it)(d).format("MM/DD")), 1)
            ], 10, Yf))), 128))
          ])
        ])) : $e("", !0),
        w("div", Gf, [
          Tt(io, {
            name: "list-fade",
            mode: "out-in"
          }, {
            default: lo(() => [
              (H(), Y("div", {
                key: a.value || "none",
                class: "space-y-6"
              }, [
                h.value.length > 0 ? (H(), Y(Ce, { key: 0 }, [
                  w("div", Kf, [
                    w("h2", qf, " Showing " + X(a.value) + " • " + X(h.value.length) + " Bookings ", 1)
                  ]),
                  (H(!0), Y(Ce, null, Ke(h.value, (d) => {
                    var v, T;
                    return H(), Y("div", {
                      key: d.booking_id,
                      class: Pe(["group rounded-[2.5rem] p-3 pr-8 shadow-sm border border-slate-100 hover:shadow-2xl hover:shadow-indigo-700 hover:border-indigo-100 transition-all duration-700", [
                        d.status === 1 ? "bg-orange-100" : "",
                        // 待處理 (Pending)
                        d.status === 2 ? "bg-green-100" : "",
                        // 已確認 (Confirmed)
                        d.status === 3 ? "bg-red-100" : "",
                        // 已取消 (Cancelled)
                        [1, 2, 3].includes(d.status) ? "" : "bg-white"
                        // 預設
                      ]])
                    }, [
                      w("div", Xf, [
                        w("div", {
                          class: Pe([[`bg-${m((T = (v = d.table_reservations) == null ? void 0 : v[0]) == null ? void 0 : T.booking_period.Lower)}-100/50`], "flex items-center gap-5 p-5 rounded-[2rem] md:w-80 transition-colors group-hover:bg-indigo-50"])
                        }, [
                          d.status !== 3 ? (H(), Y("div", zf, [
                            (H(!0), Y(Ce, null, Ke(d.table_reservations, (y) => (H(), Y("div", {
                              key: y.id,
                              class: Pe([[`bg-${m(y.booking_period.Lower)}-700`], "w-16 h-16 text-white rounded-2xl flex flex-col items-center justify-center border-4 border-white shadow-md transition-all duration-700 group-hover:rotate-6 group-hover:scale-110"])
                            }, [
                              k[4] || (k[4] = w("span", { class: "text-[8px] font-black opacity-60 uppercase mb-1" }, "Tab", -1)),
                              w("span", Jf, X(y.table_id), 1)
                            ], 2))), 128))
                          ])) : $e("", !0),
                          w("div", Zf, [
                            w("div", {
                              class: Pe([[`text-${m(d.start_time)}-700`], "text-2xl font-black tabular-nums tracking-tighter"])
                            }, X(N(d.start_time)), 3)
                          ])
                        ], 2),
                        w("div", Qf, [
                          w("div", em, [
                            w("span", tm, X(d.guest_name), 1),
                            w("div", nm, X(d.guest_count) + " 人 ", 1)
                          ]),
                          w("div", om, [
                            w("span", sm, "📞 " + X(d.phone_number), 1),
                            d.email ? (H(), Y("span", rm, "|")) : $e("", !0),
                            d.email ? (H(), Y("span", am, "✉️ " + X(d.email), 1)) : $e("", !0)
                          ])
                        ]),
                        w("div", im, [
                          w("div", {
                            class: Pe([x(d.status), "px-6 py-2 rounded-2xl text-[11px] font-black uppercase tracking-widest border transition-all shadow-sm"])
                          }, X(d.status === 2 ? "✓ Confirmed" : d.status === 1 ? "• Pending" : "X Cancel"), 3)
                        ])
                      ])
                    ], 2);
                  }), 128))
                ], 64)) : ie(o) ? $e("", !0) : (H(), Y("div", lm, [
                  k[5] || (k[5] = w("div", { class: "text-6xl mb-6 grayscale opacity-20" }, "📅", -1)),
                  w("h2", cm, X(l.value.length > 0 ? "No bookings for this date" : "No reservations found"), 1)
                ]))
              ]))
            ]),
            _: 1
          })
        ])
      ])
    ]));
  }
}), hm = /* @__PURE__ */ co(um, [["__scopeId", "data-v-ca898909"]]);
export {
  hm as AdminReservationList,
  mm as BookingConfigPage,
  pm as ReservationPage,
  aa as useBookingConfig,
  tf as useBookingOrder,
  Of as useReservationAdmin
};
